var Co = Object.defineProperty;
var ea = (e) => {
  throw TypeError(e);
};
var xo = (e, t, r) => t in e ? Co(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ce = (e, t, r) => xo(e, typeof t != "symbol" ? t + "" : t, r), ta = (e, t, r) => t.has(e) || ea("Cannot " + r);
var g = (e, t, r) => (ta(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ve = (e, t, r) => t.has(e) ? ea("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ge = (e, t, r, n) => (ta(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var Io = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function Oo(e) {
  return e;
}
function Se(e, t, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return l(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function _(e, t, r, n, a, s, i, o, l) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return l(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var d = arguments[0], y = 1; y < arguments.length; y++)
        d = arguments[y](d);
      return d;
    }
  }
}
var ko = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, Io([a], n, !1));
    };
  };
}, Po = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Vo = function(e) {
  return Po(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, as = function(e) {
  return e._tag === "Some";
}, ss = { _tag: "None" }, is = function(e) {
  return { _tag: "Some", value: e };
}, No = function(e) {
  return e._tag === "Left";
}, Mo = function(e) {
  return e._tag === "Right";
}, jo = function(e) {
  return { _tag: "Left", left: e };
}, Do = function(e) {
  return { _tag: "Right", right: e };
}, Ho = function(e) {
  return [e];
}, Lo = [], Uo = Object.prototype.hasOwnProperty, qo = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, Ko = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        Uo.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, Nr = function() {
  return { concat: Oo };
}, Bo = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, Zo = qo, ra = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, Fo = Lo, Go = function(e, t) {
  return e < 0 || e >= t.length;
}, Wo = function(e) {
  return function(t) {
    return ra(ra([], t, !0), [e], !1);
  };
}, Jo = Wo, zo = Ho, le = {
  equals: function(e, t) {
    return e === t;
  }
}, Qo = {
  concat: function(e, t) {
    return e + t;
  }
}, Yo = "", ln = {
  concat: Qo.concat,
  empty: Yo
};
le.equals;
var os = function(e) {
  return e.trim();
}, cs = function(e) {
  return e.length === 0;
}, jt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function us(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Xo() {
  this.__data__ = [], this.size = 0;
}
var ec = Xo;
function tc(e, t) {
  return e === t || e !== e && t !== t;
}
var dn = tc, rc = dn;
function nc(e, t) {
  for (var r = e.length; r--; )
    if (rc(e[r][0], t))
      return r;
  return -1;
}
var ur = nc, ac = ur, sc = Array.prototype, ic = sc.splice;
function oc(e) {
  var t = this.__data__, r = ac(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : ic.call(t, r, 1), --this.size, !0;
}
var cc = oc, uc = ur;
function lc(e) {
  var t = this.__data__, r = uc(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var dc = lc, fc = ur;
function hc(e) {
  return fc(this.__data__, e) > -1;
}
var pc = hc, yc = ur;
function mc(e, t) {
  var r = this.__data__, n = yc(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var vc = mc, gc = ec, _c = cc, bc = dc, Sc = pc, Ac = vc;
function ct(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ct.prototype.clear = gc;
ct.prototype.delete = _c;
ct.prototype.get = bc;
ct.prototype.has = Sc;
ct.prototype.set = Ac;
var lr = ct, Tc = lr;
function Ec() {
  this.__data__ = new Tc(), this.size = 0;
}
var $c = Ec;
function wc(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Rc = wc;
function Cc(e) {
  return this.__data__.get(e);
}
var xc = Cc;
function Ic(e) {
  return this.__data__.has(e);
}
var Oc = Ic, kc = typeof jt == "object" && jt && jt.Object === Object && jt, ls = kc, Pc = ls, Vc = typeof self == "object" && self && self.Object === Object && self, Nc = Pc || Vc || Function("return this")(), ne = Nc, Mc = ne, jc = Mc.Symbol, dr = jc, na = dr, ds = Object.prototype, Dc = ds.hasOwnProperty, Hc = ds.toString, vt = na ? na.toStringTag : void 0;
function Lc(e) {
  var t = Dc.call(e, vt), r = e[vt];
  try {
    e[vt] = void 0;
    var n = !0;
  } catch {
  }
  var a = Hc.call(e);
  return n && (t ? e[vt] = r : delete e[vt]), a;
}
var Uc = Lc, qc = Object.prototype, Kc = qc.toString;
function Bc(e) {
  return Kc.call(e);
}
var Zc = Bc, aa = dr, Fc = Uc, Gc = Zc, Wc = "[object Null]", Jc = "[object Undefined]", sa = aa ? aa.toStringTag : void 0;
function zc(e) {
  return e == null ? e === void 0 ? Jc : Wc : sa && sa in Object(e) ? Fc(e) : Gc(e);
}
var fr = zc;
function Qc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var wt = Qc, Yc = fr, Xc = wt, eu = "[object AsyncFunction]", tu = "[object Function]", ru = "[object GeneratorFunction]", nu = "[object Proxy]";
function au(e) {
  if (!Xc(e))
    return !1;
  var t = Yc(e);
  return t == tu || t == ru || t == eu || t == nu;
}
var fs = au, su = ne, iu = su["__core-js_shared__"], ou = iu, Mr = ou, ia = function() {
  var e = /[^.]+$/.exec(Mr && Mr.keys && Mr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function cu(e) {
  return !!ia && ia in e;
}
var uu = cu, lu = Function.prototype, du = lu.toString;
function fu(e) {
  if (e != null) {
    try {
      return du.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var hs = fu, hu = fs, pu = uu, yu = wt, mu = hs, vu = /[\\^$.*+?()[\]{}|]/g, gu = /^\[object .+?Constructor\]$/, _u = Function.prototype, bu = Object.prototype, Su = _u.toString, Au = bu.hasOwnProperty, Tu = RegExp(
  "^" + Su.call(Au).replace(vu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Eu(e) {
  if (!yu(e) || pu(e))
    return !1;
  var t = hu(e) ? Tu : gu;
  return t.test(mu(e));
}
var $u = Eu;
function wu(e, t) {
  return e == null ? void 0 : e[t];
}
var Ru = wu, Cu = $u, xu = Ru;
function Iu(e, t) {
  var r = xu(e, t);
  return Cu(r) ? r : void 0;
}
var Le = Iu, Ou = Le, ku = ne, Pu = Ou(ku, "Map"), fn = Pu, Vu = Le, Nu = Vu(Object, "create"), hr = Nu, oa = hr;
function Mu() {
  this.__data__ = oa ? oa(null) : {}, this.size = 0;
}
var ju = Mu;
function Du(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Hu = Du, Lu = hr, Uu = "__lodash_hash_undefined__", qu = Object.prototype, Ku = qu.hasOwnProperty;
function Bu(e) {
  var t = this.__data__;
  if (Lu) {
    var r = t[e];
    return r === Uu ? void 0 : r;
  }
  return Ku.call(t, e) ? t[e] : void 0;
}
var Zu = Bu, Fu = hr, Gu = Object.prototype, Wu = Gu.hasOwnProperty;
function Ju(e) {
  var t = this.__data__;
  return Fu ? t[e] !== void 0 : Wu.call(t, e);
}
var zu = Ju, Qu = hr, Yu = "__lodash_hash_undefined__";
function Xu(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Qu && t === void 0 ? Yu : t, this;
}
var el = Xu, tl = ju, rl = Hu, nl = Zu, al = zu, sl = el;
function ut(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ut.prototype.clear = tl;
ut.prototype.delete = rl;
ut.prototype.get = nl;
ut.prototype.has = al;
ut.prototype.set = sl;
var il = ut, ca = il, ol = lr, cl = fn;
function ul() {
  this.size = 0, this.__data__ = {
    hash: new ca(),
    map: new (cl || ol)(),
    string: new ca()
  };
}
var ll = ul;
function dl(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var fl = dl, hl = fl;
function pl(e, t) {
  var r = e.__data__;
  return hl(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var pr = pl, yl = pr;
function ml(e) {
  var t = yl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var vl = ml, gl = pr;
function _l(e) {
  return gl(this, e).get(e);
}
var bl = _l, Sl = pr;
function Al(e) {
  return Sl(this, e).has(e);
}
var Tl = Al, El = pr;
function $l(e, t) {
  var r = El(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var wl = $l, Rl = ll, Cl = vl, xl = bl, Il = Tl, Ol = wl;
function lt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
lt.prototype.clear = Rl;
lt.prototype.delete = Cl;
lt.prototype.get = xl;
lt.prototype.has = Il;
lt.prototype.set = Ol;
var ps = lt, kl = lr, Pl = fn, Vl = ps, Nl = 200;
function Ml(e, t) {
  var r = this.__data__;
  if (r instanceof kl) {
    var n = r.__data__;
    if (!Pl || n.length < Nl - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Vl(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var jl = Ml, Dl = lr, Hl = $c, Ll = Rc, Ul = xc, ql = Oc, Kl = jl;
function dt(e) {
  var t = this.__data__ = new Dl(e);
  this.size = t.size;
}
dt.prototype.clear = Hl;
dt.prototype.delete = Ll;
dt.prototype.get = Ul;
dt.prototype.has = ql;
dt.prototype.set = Kl;
var ys = dt;
function Bl(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var Zl = Bl, Fl = Le, Gl = function() {
  try {
    var e = Fl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Wl = Gl, ua = Wl;
function Jl(e, t, r) {
  t == "__proto__" && ua ? ua(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var ms = Jl, zl = ms, Ql = dn, Yl = Object.prototype, Xl = Yl.hasOwnProperty;
function ed(e, t, r) {
  var n = e[t];
  (!(Xl.call(e, t) && Ql(n, r)) || r === void 0 && !(t in e)) && zl(e, t, r);
}
var vs = ed, td = vs, rd = ms;
function nd(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var o = t[s], l = n ? n(r[o], e[o], o, r, e) : void 0;
    l === void 0 && (l = e[o]), a ? rd(r, o, l) : td(r, o, l);
  }
  return r;
}
var yr = nd;
function ad(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var sd = ad;
function id(e) {
  return e != null && typeof e == "object";
}
var ft = id, od = fr, cd = ft, ud = "[object Arguments]";
function ld(e) {
  return cd(e) && od(e) == ud;
}
var dd = ld, la = dd, fd = ft, gs = Object.prototype, hd = gs.hasOwnProperty, pd = gs.propertyIsEnumerable, yd = la(/* @__PURE__ */ function() {
  return arguments;
}()) ? la : function(e) {
  return fd(e) && hd.call(e, "callee") && !pd.call(e, "callee");
}, md = yd, vd = Array.isArray, mr = vd, Ut = { exports: {} };
function gd() {
  return !1;
}
var _d = gd;
Ut.exports;
(function(e, t) {
  var r = ne, n = _d, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, l = o ? o.isBuffer : void 0, d = l || n;
  e.exports = d;
})(Ut, Ut.exports);
var hn = Ut.exports, bd = 9007199254740991, Sd = /^(?:0|[1-9]\d*)$/;
function Ad(e, t) {
  var r = typeof e;
  return t = t ?? bd, !!t && (r == "number" || r != "symbol" && Sd.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Td = Ad, Ed = 9007199254740991;
function $d(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ed;
}
var _s = $d, wd = fr, Rd = _s, Cd = ft, xd = "[object Arguments]", Id = "[object Array]", Od = "[object Boolean]", kd = "[object Date]", Pd = "[object Error]", Vd = "[object Function]", Nd = "[object Map]", Md = "[object Number]", jd = "[object Object]", Dd = "[object RegExp]", Hd = "[object Set]", Ld = "[object String]", Ud = "[object WeakMap]", qd = "[object ArrayBuffer]", Kd = "[object DataView]", Bd = "[object Float32Array]", Zd = "[object Float64Array]", Fd = "[object Int8Array]", Gd = "[object Int16Array]", Wd = "[object Int32Array]", Jd = "[object Uint8Array]", zd = "[object Uint8ClampedArray]", Qd = "[object Uint16Array]", Yd = "[object Uint32Array]", k = {};
k[Bd] = k[Zd] = k[Fd] = k[Gd] = k[Wd] = k[Jd] = k[zd] = k[Qd] = k[Yd] = !0;
k[xd] = k[Id] = k[qd] = k[Od] = k[Kd] = k[kd] = k[Pd] = k[Vd] = k[Nd] = k[Md] = k[jd] = k[Dd] = k[Hd] = k[Ld] = k[Ud] = !1;
function Xd(e) {
  return Cd(e) && Rd(e.length) && !!k[wd(e)];
}
var ef = Xd;
function tf(e) {
  return function(t) {
    return e(t);
  };
}
var pn = tf, qt = { exports: {} };
qt.exports;
(function(e, t) {
  var r = ls, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(qt, qt.exports);
var yn = qt.exports, rf = ef, nf = pn, da = yn, fa = da && da.isTypedArray, af = fa ? nf(fa) : rf, bs = af, sf = sd, of = md, cf = mr, uf = hn, lf = Td, df = bs, ff = Object.prototype, hf = ff.hasOwnProperty;
function pf(e, t) {
  var r = cf(e), n = !r && of(e), a = !r && !n && uf(e), s = !r && !n && !a && df(e), i = r || n || a || s, o = i ? sf(e.length, String) : [], l = o.length;
  for (var d in e)
    (t || hf.call(e, d)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    lf(d, l))) && o.push(d);
  return o;
}
var Ss = pf, yf = Object.prototype;
function mf(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || yf;
  return e === r;
}
var mn = mf;
function vf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var As = vf, gf = As, _f = gf(Object.keys, Object), bf = _f, Sf = mn, Af = bf, Tf = Object.prototype, Ef = Tf.hasOwnProperty;
function $f(e) {
  if (!Sf(e))
    return Af(e);
  var t = [];
  for (var r in Object(e))
    Ef.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var wf = $f, Rf = fs, Cf = _s;
function xf(e) {
  return e != null && Cf(e.length) && !Rf(e);
}
var Ts = xf, If = Ss, Of = wf, kf = Ts;
function Pf(e) {
  return kf(e) ? If(e) : Of(e);
}
var vn = Pf, Vf = yr, Nf = vn;
function Mf(e, t) {
  return e && Vf(t, Nf(t), e);
}
var jf = Mf;
function Df(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Hf = Df, Lf = wt, Uf = mn, qf = Hf, Kf = Object.prototype, Bf = Kf.hasOwnProperty;
function Zf(e) {
  if (!Lf(e))
    return qf(e);
  var t = Uf(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Bf.call(e, n)) || r.push(n);
  return r;
}
var Ff = Zf, Gf = Ss, Wf = Ff, Jf = Ts;
function zf(e) {
  return Jf(e) ? Gf(e, !0) : Wf(e);
}
var gn = zf, Qf = yr, Yf = gn;
function Xf(e, t) {
  return e && Qf(t, Yf(t), e);
}
var eh = Xf, Kt = { exports: {} };
Kt.exports;
(function(e, t) {
  var r = ne, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
  function l(d, y) {
    if (y)
      return d.slice();
    var E = d.length, R = o ? o(E) : new d.constructor(E);
    return d.copy(R), R;
  }
  e.exports = l;
})(Kt, Kt.exports);
var th = Kt.exports;
function rh(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var nh = rh;
function ah(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var i = e[r];
    t(i, r, e) && (s[a++] = i);
  }
  return s;
}
var sh = ah;
function ih() {
  return [];
}
var Es = ih, oh = sh, ch = Es, uh = Object.prototype, lh = uh.propertyIsEnumerable, ha = Object.getOwnPropertySymbols, dh = ha ? function(e) {
  return e == null ? [] : (e = Object(e), oh(ha(e), function(t) {
    return lh.call(e, t);
  }));
} : ch, _n = dh, fh = yr, hh = _n;
function ph(e, t) {
  return fh(e, hh(e), t);
}
var yh = ph;
function mh(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var $s = mh, vh = As, gh = vh(Object.getPrototypeOf, Object), ws = gh, _h = $s, bh = ws, Sh = _n, Ah = Es, Th = Object.getOwnPropertySymbols, Eh = Th ? function(e) {
  for (var t = []; e; )
    _h(t, Sh(e)), e = bh(e);
  return t;
} : Ah, Rs = Eh, $h = yr, wh = Rs;
function Rh(e, t) {
  return $h(e, wh(e), t);
}
var Ch = Rh, xh = $s, Ih = mr;
function Oh(e, t, r) {
  var n = t(e);
  return Ih(e) ? n : xh(n, r(e));
}
var Cs = Oh, kh = Cs, Ph = _n, Vh = vn;
function Nh(e) {
  return kh(e, Vh, Ph);
}
var xs = Nh, Mh = Cs, jh = Rs, Dh = gn;
function Hh(e) {
  return Mh(e, Dh, jh);
}
var Lh = Hh, Uh = Le, qh = ne, Kh = Uh(qh, "DataView"), Bh = Kh, Zh = Le, Fh = ne, Gh = Zh(Fh, "Promise"), Wh = Gh, Jh = Le, zh = ne, Qh = Jh(zh, "Set"), Yh = Qh, Xh = Le, ep = ne, tp = Xh(ep, "WeakMap"), rp = tp, Zr = Bh, Fr = fn, Gr = Wh, Wr = Yh, Jr = rp, Is = fr, ht = hs, pa = "[object Map]", np = "[object Object]", ya = "[object Promise]", ma = "[object Set]", va = "[object WeakMap]", ga = "[object DataView]", ap = ht(Zr), sp = ht(Fr), ip = ht(Gr), op = ht(Wr), cp = ht(Jr), Ne = Is;
(Zr && Ne(new Zr(new ArrayBuffer(1))) != ga || Fr && Ne(new Fr()) != pa || Gr && Ne(Gr.resolve()) != ya || Wr && Ne(new Wr()) != ma || Jr && Ne(new Jr()) != va) && (Ne = function(e) {
  var t = Is(e), r = t == np ? e.constructor : void 0, n = r ? ht(r) : "";
  if (n)
    switch (n) {
      case ap:
        return ga;
      case sp:
        return pa;
      case ip:
        return ya;
      case op:
        return ma;
      case cp:
        return va;
    }
  return t;
});
var vr = Ne, up = Object.prototype, lp = up.hasOwnProperty;
function dp(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && lp.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var fp = dp, hp = ne, pp = hp.Uint8Array, Os = pp, _a = Os;
function yp(e) {
  var t = new e.constructor(e.byteLength);
  return new _a(t).set(new _a(e)), t;
}
var bn = yp, mp = bn;
function vp(e, t) {
  var r = t ? mp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var gp = vp, _p = /\w*$/;
function bp(e) {
  var t = new e.constructor(e.source, _p.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Sp = bp, ba = dr, Sa = ba ? ba.prototype : void 0, Aa = Sa ? Sa.valueOf : void 0;
function Ap(e) {
  return Aa ? Object(Aa.call(e)) : {};
}
var Tp = Ap, Ep = bn;
function $p(e, t) {
  var r = t ? Ep(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var wp = $p, Rp = bn, Cp = gp, xp = Sp, Ip = Tp, Op = wp, kp = "[object Boolean]", Pp = "[object Date]", Vp = "[object Map]", Np = "[object Number]", Mp = "[object RegExp]", jp = "[object Set]", Dp = "[object String]", Hp = "[object Symbol]", Lp = "[object ArrayBuffer]", Up = "[object DataView]", qp = "[object Float32Array]", Kp = "[object Float64Array]", Bp = "[object Int8Array]", Zp = "[object Int16Array]", Fp = "[object Int32Array]", Gp = "[object Uint8Array]", Wp = "[object Uint8ClampedArray]", Jp = "[object Uint16Array]", zp = "[object Uint32Array]";
function Qp(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case Lp:
      return Rp(e);
    case kp:
    case Pp:
      return new n(+e);
    case Up:
      return Cp(e, r);
    case qp:
    case Kp:
    case Bp:
    case Zp:
    case Fp:
    case Gp:
    case Wp:
    case Jp:
    case zp:
      return Op(e, r);
    case Vp:
      return new n();
    case Np:
    case Dp:
      return new n(e);
    case Mp:
      return xp(e);
    case jp:
      return new n();
    case Hp:
      return Ip(e);
  }
}
var Yp = Qp, Xp = wt, Ta = Object.create, ey = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Xp(t))
      return {};
    if (Ta)
      return Ta(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), ty = ey, ry = ty, ny = ws, ay = mn;
function sy(e) {
  return typeof e.constructor == "function" && !ay(e) ? ry(ny(e)) : {};
}
var iy = sy, oy = vr, cy = ft, uy = "[object Map]";
function ly(e) {
  return cy(e) && oy(e) == uy;
}
var dy = ly, fy = dy, hy = pn, Ea = yn, $a = Ea && Ea.isMap, py = $a ? hy($a) : fy, yy = py, my = vr, vy = ft, gy = "[object Set]";
function _y(e) {
  return vy(e) && my(e) == gy;
}
var by = _y, Sy = by, Ay = pn, wa = yn, Ra = wa && wa.isSet, Ty = Ra ? Ay(Ra) : Sy, Ey = Ty, $y = ys, wy = Zl, Ry = vs, Cy = jf, xy = eh, Iy = th, Oy = nh, ky = yh, Py = Ch, Vy = xs, Ny = Lh, My = vr, jy = fp, Dy = Yp, Hy = iy, Ly = mr, Uy = hn, qy = yy, Ky = wt, By = Ey, Zy = vn, Fy = gn, Gy = 1, Wy = 2, Jy = 4, ks = "[object Arguments]", zy = "[object Array]", Qy = "[object Boolean]", Yy = "[object Date]", Xy = "[object Error]", Ps = "[object Function]", em = "[object GeneratorFunction]", tm = "[object Map]", rm = "[object Number]", Vs = "[object Object]", nm = "[object RegExp]", am = "[object Set]", sm = "[object String]", im = "[object Symbol]", om = "[object WeakMap]", cm = "[object ArrayBuffer]", um = "[object DataView]", lm = "[object Float32Array]", dm = "[object Float64Array]", fm = "[object Int8Array]", hm = "[object Int16Array]", pm = "[object Int32Array]", ym = "[object Uint8Array]", mm = "[object Uint8ClampedArray]", vm = "[object Uint16Array]", gm = "[object Uint32Array]", I = {};
I[ks] = I[zy] = I[cm] = I[um] = I[Qy] = I[Yy] = I[lm] = I[dm] = I[fm] = I[hm] = I[pm] = I[tm] = I[rm] = I[Vs] = I[nm] = I[am] = I[sm] = I[im] = I[ym] = I[mm] = I[vm] = I[gm] = !0;
I[Xy] = I[Ps] = I[om] = !1;
function Lt(e, t, r, n, a, s) {
  var i, o = t & Gy, l = t & Wy, d = t & Jy;
  if (r && (i = a ? r(e, n, a, s) : r(e)), i !== void 0)
    return i;
  if (!Ky(e))
    return e;
  var y = Ly(e);
  if (y) {
    if (i = jy(e), !o)
      return Oy(e, i);
  } else {
    var E = My(e), R = E == Ps || E == em;
    if (Uy(e))
      return Iy(e, o);
    if (E == Vs || E == ks || R && !a) {
      if (i = l || R ? {} : Hy(e), !o)
        return l ? Py(e, xy(i, e)) : ky(e, Cy(i, e));
    } else {
      if (!I[E])
        return a ? e : {};
      i = Dy(e, E, o);
    }
  }
  s || (s = new $y());
  var F = s.get(e);
  if (F)
    return F;
  s.set(e, i), By(e) ? e.forEach(function(H) {
    i.add(Lt(H, t, r, H, e, s));
  }) : qy(e) && e.forEach(function(H, K) {
    i.set(K, Lt(H, t, r, K, e, s));
  });
  var q = d ? l ? Ny : Vy : l ? Fy : Zy, G = y ? void 0 : q(e);
  return wy(G || e, function(H, K) {
    G && (K = H, H = e[K]), Ry(i, K, Lt(H, t, r, K, e, s));
  }), i;
}
var _m = Lt, bm = _m, Sm = 1, Am = 4;
function Tm(e) {
  return bm(e, Sm | Am);
}
var Em = Tm;
const $m = /* @__PURE__ */ us(Em);
var x;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(x || (x = {}));
var Ca;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(Ca || (Ca = {}));
const m = x.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), _e = (e) => {
  switch (typeof e) {
    case "undefined":
      return m.undefined;
    case "string":
      return m.string;
    case "number":
      return Number.isNaN(e) ? m.nan : m.number;
    case "boolean":
      return m.boolean;
    case "function":
      return m.function;
    case "bigint":
      return m.bigint;
    case "symbol":
      return m.symbol;
    case "object":
      return Array.isArray(e) ? m.array : e === null ? m.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? m.promise : typeof Map < "u" && e instanceof Map ? m.map : typeof Set < "u" && e instanceof Set ? m.set : typeof Date < "u" && e instanceof Date ? m.date : m.object;
    default:
      return m.unknown;
  }
}, h = x.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class pe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, l = 0;
          for (; l < i.path.length; ) {
            const d = i.path[l];
            l === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(r(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof pe))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, x.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
pe.create = (e) => new pe(e);
const zr = (e, t) => {
  let r;
  switch (e.code) {
    case h.invalid_type:
      e.received === m.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case h.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, x.jsonStringifyReplacer)}`;
      break;
    case h.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${x.joinValues(e.keys, ", ")}`;
      break;
    case h.invalid_union:
      r = "Invalid input";
      break;
    case h.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${x.joinValues(e.options)}`;
      break;
    case h.invalid_enum_value:
      r = `Invalid enum value. Expected ${x.joinValues(e.options)}, received '${e.received}'`;
      break;
    case h.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case h.invalid_return_type:
      r = "Invalid function return type";
      break;
    case h.invalid_date:
      r = "Invalid date";
      break;
    case h.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : x.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case h.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case h.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case h.custom:
      r = "Invalid input";
      break;
    case h.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case h.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case h.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, x.assertNever(e);
  }
  return { message: r };
};
let wm = zr;
function Rm() {
  return wm;
}
const Cm = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    o = d(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function p(e, t) {
  const r = Rm(), n = Cm({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === zr ? void 0 : zr
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class B {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return T;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return B.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return T;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const T = Object.freeze({
  status: "aborted"
}), _t = (e) => ({ status: "dirty", value: e }), Q = (e) => ({ status: "valid", value: e }), xa = (e) => e.status === "aborted", Ia = (e) => e.status === "dirty", Xe = (e) => e.status === "valid", Bt = (e) => typeof Promise < "u" && e instanceof Promise;
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
var Zt = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, Ns = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, bt, St;
class te {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Oa = (e, t) => {
  if (Xe(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new pe(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function $(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: l } = e;
    return i.code === "invalid_enum_value" ? { message: l ?? o.defaultError } : typeof o.data > "u" ? { message: l ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: l ?? r ?? o.defaultError };
  }, description: a };
}
class C {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return _e(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: _e(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new B(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: _e(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (Bt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: _e(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return Oa(n, a);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: _e(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: r });
        return Xe(s) ? {
          value: s.value
        } : {
          issues: r.common.issues
        };
      } catch (s) {
        (a = (n = s == null ? void 0 : s.message) == null ? void 0 : n.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((s) => Xe(s) ? {
      value: s.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: _e(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (Bt(a) ? a : Promise.resolve(a));
    return Oa(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: h.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((l) => l ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new ye({
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return he.create(this, this._def);
  }
  nullable() {
    return He.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ee.create(this);
  }
  promise() {
    return er.create(this, this._def);
  }
  or(t) {
    return Wt.create([this, t], this._def);
  }
  and(t) {
    return Jt.create(this, t, this._def);
  }
  transform(t) {
    return new ye({
      ...$(this._def),
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new tr({
      ...$(this._def),
      innerType: this,
      defaultValue: r,
      typeName: b.ZodDefault
    });
  }
  brand() {
    return new Hs({
      typeName: b.ZodBranded,
      type: this,
      ...$(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new rr({
      ...$(this._def),
      innerType: this,
      catchValue: r,
      typeName: b.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return An.create(this, t);
  }
  readonly() {
    return nr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const xm = /^c[^\s-]{8,}$/i, Im = /^[0-9a-z]+$/, Om = /^[0-9A-HJKMNP-TV-Z]{26}$/i, km = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Pm = /^[a-z0-9_-]{21}$/i, Vm = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Nm = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Mm = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, jm = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let jr;
const Dm = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Hm = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Lm = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Um = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, qm = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Km = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ms = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Bm = new RegExp(`^${Ms}$`);
function js(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function Zm(e) {
  return new RegExp(`^${js(e)}$`);
}
function Fm(e) {
  let t = `${Ms}T${js(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Gm(e, t) {
  return !!((t === "v4" || !t) && Dm.test(e) || (t === "v6" || !t) && Lm.test(e));
}
function Wm(e, t) {
  if (!Vm.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Jm(e, t) {
  return !!((t === "v4" || !t) && Hm.test(e) || (t === "v6" || !t) && Um.test(e));
}
class fe extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== m.string) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.string,
        received: s.parsedType
      }), T;
    }
    const n = new B();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? p(a, {
          code: h.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && p(a, {
          code: h.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Mm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "email",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        jr || (jr = new RegExp(jm, "u")), jr.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "emoji",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        km.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "uuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        Pm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "nanoid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        xm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        Im.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "cuid2",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        Om.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
          validation: "ulid",
          code: h.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), p(a, {
            validation: "url",
            code: h.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "regex",
        code: h.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Fm(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Bm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? Zm(s).test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Nm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "duration",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Gm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "ip",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Wm(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "jwt",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Jm(t.data, s.version) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "cidr",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? qm.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Km.test(t.data) || (a = this._getOrReturnCtx(t, a), p(a, {
        validation: "base64url",
        code: h.invalid_string,
        message: s.message
      }), n.dirty()) : x.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: h.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new fe({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...v.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...v.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...v.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...v.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new fe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new fe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new fe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
fe.create = (e) => new fe({
  checks: [],
  typeName: b.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...$(e)
});
function zm(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class et extends C {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== m.number) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.number,
        received: s.parsedType
      }), T;
    }
    let n;
    const a = new B();
    for (const s of this._def.checks)
      s.kind === "int" ? x.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? zm(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_finite,
        message: s.message
      }), a.dirty()) : x.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new et({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new et({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && x.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
et.create = (e) => new et({
  checks: [],
  typeName: b.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...$(e)
});
class tt extends C {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== m.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new B();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: h.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : x.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.bigint,
      received: r.parsedType
    }), T;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, a) {
    return new tt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new tt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
tt.create = (e) => new tt({
  checks: [],
  typeName: b.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...$(e)
});
class Qr extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== m.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.boolean,
        received: n.parsedType
      }), T;
    }
    return Q(t.data);
  }
}
Qr.create = (e) => new Qr({
  typeName: b.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...$(e)
});
class At extends C {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== m.date) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_type,
        expected: m.date,
        received: s.parsedType
      }), T;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return p(s, {
        code: h.invalid_date
      }), T;
    }
    const n = new B();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), p(a, {
        code: h.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : x.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new At({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
At.create = (e) => new At({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: b.ZodDate,
  ...$(e)
});
class Yr extends C {
  _parse(t) {
    if (this._getType(t) !== m.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.symbol,
        received: n.parsedType
      }), T;
    }
    return Q(t.data);
  }
}
Yr.create = (e) => new Yr({
  typeName: b.ZodSymbol,
  ...$(e)
});
class Ft extends C {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.undefined,
        received: n.parsedType
      }), T;
    }
    return Q(t.data);
  }
}
Ft.create = (e) => new Ft({
  typeName: b.ZodUndefined,
  ...$(e)
});
class Gt extends C {
  _parse(t) {
    if (this._getType(t) !== m.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.null,
        received: n.parsedType
      }), T;
    }
    return Q(t.data);
  }
}
Gt.create = (e) => new Gt({
  typeName: b.ZodNull,
  ...$(e)
});
class Tt extends C {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Q(t.data);
  }
}
Tt.create = (e) => new Tt({
  typeName: b.ZodAny,
  ...$(e)
});
class Xr extends C {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Q(t.data);
  }
}
Xr.create = (e) => new Xr({
  typeName: b.ZodUnknown,
  ...$(e)
});
class Ae extends C {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: h.invalid_type,
      expected: m.never,
      received: r.parsedType
    }), T;
  }
}
Ae.create = (e) => new Ae({
  typeName: b.ZodNever,
  ...$(e)
});
class en extends C {
  _parse(t) {
    if (this._getType(t) !== m.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.void,
        received: n.parsedType
      }), T;
    }
    return Q(t.data);
  }
}
en.create = (e) => new en({
  typeName: b.ZodVoid,
  ...$(e)
});
class ee extends C {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== m.array)
      return p(r, {
        code: h.invalid_type,
        expected: m.array,
        received: r.parsedType
      }), T;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (p(r, {
        code: i ? h.too_big : h.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (p(r, {
      code: h.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (p(r, {
      code: h.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new te(r, i, r.path, o)))).then((i) => B.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new te(r, i, r.path, o)));
    return B.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new ee({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new ee({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new ee({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
ee.create = (e, t) => new ee({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: b.ZodArray,
  ...$(t)
});
function Ge(e) {
  if (e instanceof N) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = he.create(Ge(n));
    }
    return new N({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof ee ? new ee({
    ...e._def,
    type: Ge(e.element)
  }) : e instanceof he ? he.create(Ge(e.unwrap())) : e instanceof He ? He.create(Ge(e.unwrap())) : e instanceof je ? je.create(e.items.map((t) => Ge(t))) : e;
}
class N extends C {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = x.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== m.object) {
      const d = this._getOrReturnCtx(t);
      return p(d, {
        code: h.invalid_type,
        expected: m.object,
        received: d.parsedType
      }), T;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ae && this._def.unknownKeys === "strip"))
      for (const d in a.data)
        i.includes(d) || o.push(d);
    const l = [];
    for (const d of i) {
      const y = s[d], E = a.data[d];
      l.push({
        key: { status: "valid", value: d },
        value: y._parse(new te(a, E, a.path, d)),
        alwaysSet: d in a.data
      });
    }
    if (this._def.catchall instanceof Ae) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const y of o)
          l.push({
            key: { status: "valid", value: y },
            value: { status: "valid", value: a.data[y] }
          });
      else if (d === "strict")
        o.length > 0 && (p(a, {
          code: h.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const y of o) {
        const E = a.data[y];
        l.push({
          key: { status: "valid", value: y },
          value: d._parse(
            new te(a, E, a.path, y)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: y in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const y of l) {
        const E = await y.key, R = await y.value;
        d.push({
          key: E,
          value: R,
          alwaysSet: y.alwaysSet
        });
      }
      return d;
    }).then((d) => B.mergeObjectSync(n, d)) : B.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new N({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: v.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new N({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new N({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new N({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new N({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: b.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new N({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of x.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of x.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Ge(this);
  }
  partial(t) {
    const r = {};
    for (const n of x.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of x.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof he; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new N({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ds(x.objectKeys(this.shape));
  }
}
N.create = (e, t) => new N({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Ae.create(),
  typeName: b.ZodObject,
  ...$(t)
});
N.strictCreate = (e, t) => new N({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Ae.create(),
  typeName: b.ZodObject,
  ...$(t)
});
N.lazycreate = (e, t) => new N({
  shape: e,
  unknownKeys: "strip",
  catchall: Ae.create(),
  typeName: b.ZodObject,
  ...$(t)
});
class Wt extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new pe(o.ctx.common.issues));
      return p(r, {
        code: h.invalid_union,
        unionErrors: i
      }), T;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, y = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (y.status === "valid")
          return y;
        y.status === "dirty" && !s && (s = { result: y, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((l) => new pe(l));
      return p(r, {
        code: h.invalid_union,
        unionErrors: o
      }), T;
    }
  }
  get options() {
    return this._def.options;
  }
}
Wt.create = (e, t) => new Wt({
  options: e,
  typeName: b.ZodUnion,
  ...$(t)
});
const de = (e) => e instanceof Qt ? de(e.schema) : e instanceof ye ? de(e.innerType()) : e instanceof Yt ? [e.value] : e instanceof De ? e.options : e instanceof Xt ? x.objectValues(e.enum) : e instanceof tr ? de(e._def.innerType) : e instanceof Ft ? [void 0] : e instanceof Gt ? [null] : e instanceof he ? [void 0, ...de(e.unwrap())] : e instanceof He ? [null, ...de(e.unwrap())] : e instanceof Hs || e instanceof nr ? de(e.unwrap()) : e instanceof rr ? de(e._def.innerType) : [];
class Sn extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.object)
      return p(r, {
        code: h.invalid_type,
        expected: m.object,
        received: r.parsedType
      }), T;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: h.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), T);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = de(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new Sn({
      typeName: b.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...$(n)
    });
  }
}
function tn(e, t) {
  const r = _e(e), n = _e(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === m.object && n === m.object) {
    const a = x.objectKeys(t), s = x.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const l = tn(e[o], t[o]);
      if (!l.valid)
        return { valid: !1 };
      i[o] = l.data;
    }
    return { valid: !0, data: i };
  } else if (r === m.array && n === m.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], l = tn(i, o);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === m.date && n === m.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Jt extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (xa(s) || xa(i))
        return T;
      const o = tn(s.value, i.value);
      return o.valid ? ((Ia(s) || Ia(i)) && r.dirty(), { status: r.value, value: o.data }) : (p(n, {
        code: h.invalid_intersection_types
      }), T);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Jt.create = (e, t, r) => new Jt({
  left: e,
  right: t,
  typeName: b.ZodIntersection,
  ...$(r)
});
class je extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.array)
      return p(n, {
        code: h.invalid_type,
        expected: m.array,
        received: n.parsedType
      }), T;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: h.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), T;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: h.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new te(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => B.mergeArray(r, i)) : B.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new je({
      ...this._def,
      rest: t
    });
  }
}
je.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new je({
    items: e,
    typeName: b.ZodTuple,
    rest: null,
    ...$(t)
  });
};
class zt extends C {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.object)
      return p(n, {
        code: h.invalid_type,
        expected: m.object,
        received: n.parsedType
      }), T;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new te(n, o, n.path, o)),
        value: i._parse(new te(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? B.mergeObjectAsync(r, a) : B.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof C ? new zt({
      keyType: t,
      valueType: r,
      typeName: b.ZodRecord,
      ...$(n)
    }) : new zt({
      keyType: fe.create(),
      valueType: t,
      typeName: b.ZodRecord,
      ...$(r)
    });
  }
}
class rn extends C {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.map)
      return p(n, {
        code: h.invalid_type,
        expected: m.map,
        received: n.parsedType
      }), T;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, l], d) => ({
      key: a._parse(new te(n, o, n.path, [d, "key"])),
      value: s._parse(new te(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of i) {
          const d = await l.key, y = await l.value;
          if (d.status === "aborted" || y.status === "aborted")
            return T;
          (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of i) {
        const d = l.key, y = l.value;
        if (d.status === "aborted" || y.status === "aborted")
          return T;
        (d.status === "dirty" || y.status === "dirty") && r.dirty(), o.set(d.value, y.value);
      }
      return { status: r.value, value: o };
    }
  }
}
rn.create = (e, t, r) => new rn({
  valueType: t,
  keyType: e,
  typeName: b.ZodMap,
  ...$(r)
});
class rt extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== m.set)
      return p(n, {
        code: h.invalid_type,
        expected: m.set,
        received: n.parsedType
      }), T;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (p(n, {
      code: h.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (p(n, {
      code: h.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(l) {
      const d = /* @__PURE__ */ new Set();
      for (const y of l) {
        if (y.status === "aborted")
          return T;
        y.status === "dirty" && r.dirty(), d.add(y.value);
      }
      return { status: r.value, value: d };
    }
    const o = [...n.data.values()].map((l, d) => s._parse(new te(n, l, n.path, d)));
    return n.common.async ? Promise.all(o).then((l) => i(l)) : i(o);
  }
  min(t, r) {
    return new rt({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new rt({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
rt.create = (e, t) => new rt({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: b.ZodSet,
  ...$(t)
});
class Qt extends C {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Qt.create = (e, t) => new Qt({
  getter: e,
  typeName: b.ZodLazy,
  ...$(t)
});
class Yt extends C {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: h.invalid_literal,
        expected: this._def.value
      }), T;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Yt.create = (e, t) => new Yt({
  value: e,
  typeName: b.ZodLiteral,
  ...$(t)
});
function Ds(e, t) {
  return new De({
    values: e,
    typeName: b.ZodEnum,
    ...$(t)
  });
}
class De extends C {
  constructor() {
    super(...arguments), bt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: x.joinValues(n),
        received: r.parsedType,
        code: h.invalid_type
      }), T;
    }
    if (Zt(this, bt, "f") || Ns(this, bt, new Set(this._def.values), "f"), !Zt(this, bt, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: h.invalid_enum_value,
        options: n
      }), T;
    }
    return Q(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return De.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return De.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
bt = /* @__PURE__ */ new WeakMap();
De.create = Ds;
class Xt extends C {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(t) {
    const r = x.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== m.string && n.parsedType !== m.number) {
      const a = x.objectValues(r);
      return p(n, {
        expected: x.joinValues(a),
        received: n.parsedType,
        code: h.invalid_type
      }), T;
    }
    if (Zt(this, St, "f") || Ns(this, St, new Set(x.getValidEnumValues(this._def.values)), "f"), !Zt(this, St, "f").has(t.data)) {
      const a = x.objectValues(r);
      return p(n, {
        received: n.data,
        code: h.invalid_enum_value,
        options: a
      }), T;
    }
    return Q(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
St = /* @__PURE__ */ new WeakMap();
Xt.create = (e, t) => new Xt({
  values: e,
  typeName: b.ZodNativeEnum,
  ...$(t)
});
class er extends C {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== m.promise && r.common.async === !1)
      return p(r, {
        code: h.invalid_type,
        expected: m.promise,
        received: r.parsedType
      }), T;
    const n = r.parsedType === m.promise ? r.data : Promise.resolve(r.data);
    return Q(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
er.create = (e, t) => new er({
  type: e,
  typeName: b.ZodPromise,
  ...$(t)
});
class ye extends C {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === b.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        p(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return T;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? T : l.status === "dirty" || r.value === "dirty" ? _t(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return T;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? T : o.status === "dirty" || r.value === "dirty" ? _t(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const l = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? T : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? T : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Xe(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Xe(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    x.assertNever(a);
  }
}
ye.create = (e, t, r) => new ye({
  schema: e,
  typeName: b.ZodEffects,
  effect: t,
  ...$(r)
});
ye.createWithPreprocess = (e, t, r) => new ye({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: b.ZodEffects,
  ...$(r)
});
class he extends C {
  _parse(t) {
    return this._getType(t) === m.undefined ? Q(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
he.create = (e, t) => new he({
  innerType: e,
  typeName: b.ZodOptional,
  ...$(t)
});
class He extends C {
  _parse(t) {
    return this._getType(t) === m.null ? Q(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
He.create = (e, t) => new He({
  innerType: e,
  typeName: b.ZodNullable,
  ...$(t)
});
class tr extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === m.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
tr.create = (e, t) => new tr({
  innerType: e,
  typeName: b.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...$(t)
});
class rr extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Bt(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new pe(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new pe(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
rr.create = (e, t) => new rr({
  innerType: e,
  typeName: b.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...$(t)
});
class nn extends C {
  _parse(t) {
    if (this._getType(t) !== m.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: h.invalid_type,
        expected: m.nan,
        received: n.parsedType
      }), T;
    }
    return { status: "valid", value: t.data };
  }
}
nn.create = (e) => new nn({
  typeName: b.ZodNaN,
  ...$(e)
});
class Hs extends C {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class An extends C {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? T : s.status === "dirty" ? (r.dirty(), _t(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? T : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new An({
      in: t,
      out: r,
      typeName: b.ZodPipeline
    });
  }
}
class nr extends C {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (Xe(a) && (a.value = Object.freeze(a.value)), a);
    return Bt(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
nr.create = (e, t) => new nr({
  innerType: e,
  typeName: b.ZodReadonly,
  ...$(t)
});
function ka(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function Tn(e, t = {}, r) {
  return e ? Tt.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = ka(t, n), l = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: l });
        }
      });
    if (!s) {
      const i = ka(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : Tt.create();
}
N.lazycreate;
var b;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(b || (b = {}));
const gr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Tn((r) => r instanceof e, t), c = fe.create, pt = et.create;
nn.create;
tt.create;
const w = Qr.create;
At.create;
Yr.create;
Ft.create;
Gt.create;
const Qm = Tt.create;
Xr.create;
Ae.create;
en.create;
const A = ee.create, f = N.create;
N.strictCreate;
const O = Wt.create, P = Sn.create;
Jt.create;
je.create;
const Ls = zt.create;
rn.create;
rt.create;
const Y = Qt.create, u = Yt.create, Z = De.create;
Xt.create;
er.create;
ye.create;
const z = he.create;
He.create;
ye.createWithPreprocess;
var S = (e) => e, Ym = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t)
      return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function Ue(e) {
  return new Ym(e.versionMap, e.latestVersion, e.getVersion);
}
function nt(e) {
  return Tn((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function me(e, t) {
  return Tn((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var Xm = "__lodash_hash_undefined__";
function ev(e) {
  return this.__data__.set(e, Xm), this;
}
var tv = ev;
function rv(e) {
  return this.__data__.has(e);
}
var nv = rv, av = ps, sv = tv, iv = nv;
function ar(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new av(); ++t < r; )
    this.add(e[t]);
}
ar.prototype.add = ar.prototype.push = sv;
ar.prototype.has = iv;
var ov = ar;
function cv(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var uv = cv;
function lv(e, t) {
  return e.has(t);
}
var dv = lv, fv = ov, hv = uv, pv = dv, yv = 1, mv = 2;
function vv(e, t, r, n, a, s) {
  var i = r & yv, o = e.length, l = t.length;
  if (o != l && !(i && l > o))
    return !1;
  var d = s.get(e), y = s.get(t);
  if (d && y)
    return d == t && y == e;
  var E = -1, R = !0, F = r & mv ? new fv() : void 0;
  for (s.set(e, t), s.set(t, e); ++E < o; ) {
    var q = e[E], G = t[E];
    if (n)
      var H = i ? n(G, q, E, t, e, s) : n(q, G, E, e, t, s);
    if (H !== void 0) {
      if (H)
        continue;
      R = !1;
      break;
    }
    if (F) {
      if (!hv(t, function(K, ke) {
        if (!pv(F, ke) && (q === K || a(q, K, r, n, s)))
          return F.push(ke);
      })) {
        R = !1;
        break;
      }
    } else if (!(q === G || a(q, G, r, n, s))) {
      R = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), R;
}
var Us = vv;
function gv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var _v = gv;
function bv(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Sv = bv, Pa = dr, Va = Os, Av = dn, Tv = Us, Ev = _v, $v = Sv, wv = 1, Rv = 2, Cv = "[object Boolean]", xv = "[object Date]", Iv = "[object Error]", Ov = "[object Map]", kv = "[object Number]", Pv = "[object RegExp]", Vv = "[object Set]", Nv = "[object String]", Mv = "[object Symbol]", jv = "[object ArrayBuffer]", Dv = "[object DataView]", Na = Pa ? Pa.prototype : void 0, Dr = Na ? Na.valueOf : void 0;
function Hv(e, t, r, n, a, s, i) {
  switch (r) {
    case Dv:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case jv:
      return !(e.byteLength != t.byteLength || !s(new Va(e), new Va(t)));
    case Cv:
    case xv:
    case kv:
      return Av(+e, +t);
    case Iv:
      return e.name == t.name && e.message == t.message;
    case Pv:
    case Nv:
      return e == t + "";
    case Ov:
      var o = Ev;
    case Vv:
      var l = n & wv;
      if (o || (o = $v), e.size != t.size && !l)
        return !1;
      var d = i.get(e);
      if (d)
        return d == t;
      n |= Rv, i.set(e, t);
      var y = Tv(o(e), o(t), n, a, s, i);
      return i.delete(e), y;
    case Mv:
      if (Dr)
        return Dr.call(e) == Dr.call(t);
  }
  return !1;
}
var Lv = Hv, Ma = xs, Uv = 1, qv = Object.prototype, Kv = qv.hasOwnProperty;
function Bv(e, t, r, n, a, s) {
  var i = r & Uv, o = Ma(e), l = o.length, d = Ma(t), y = d.length;
  if (l != y && !i)
    return !1;
  for (var E = l; E--; ) {
    var R = o[E];
    if (!(i ? R in t : Kv.call(t, R)))
      return !1;
  }
  var F = s.get(e), q = s.get(t);
  if (F && q)
    return F == t && q == e;
  var G = !0;
  s.set(e, t), s.set(t, e);
  for (var H = i; ++E < l; ) {
    R = o[E];
    var K = e[R], ke = t[R];
    if (n)
      var Xn = i ? n(ke, K, R, t, e, s) : n(K, ke, R, e, t, s);
    if (!(Xn === void 0 ? K === ke || a(K, ke, r, n, s) : Xn)) {
      G = !1;
      break;
    }
    H || (H = R == "constructor");
  }
  if (G && !H) {
    var Nt = e.constructor, Mt = t.constructor;
    Nt != Mt && "constructor" in e && "constructor" in t && !(typeof Nt == "function" && Nt instanceof Nt && typeof Mt == "function" && Mt instanceof Mt) && (G = !1);
  }
  return s.delete(e), s.delete(t), G;
}
var Zv = Bv, Hr = ys, Fv = Us, Gv = Lv, Wv = Zv, ja = vr, Da = mr, Ha = hn, Jv = bs, zv = 1, La = "[object Arguments]", Ua = "[object Array]", Dt = "[object Object]", Qv = Object.prototype, qa = Qv.hasOwnProperty;
function Yv(e, t, r, n, a, s) {
  var i = Da(e), o = Da(t), l = i ? Ua : ja(e), d = o ? Ua : ja(t);
  l = l == La ? Dt : l, d = d == La ? Dt : d;
  var y = l == Dt, E = d == Dt, R = l == d;
  if (R && Ha(e)) {
    if (!Ha(t))
      return !1;
    i = !0, y = !1;
  }
  if (R && !y)
    return s || (s = new Hr()), i || Jv(e) ? Fv(e, t, r, n, a, s) : Gv(e, t, l, r, n, a, s);
  if (!(r & zv)) {
    var F = y && qa.call(e, "__wrapped__"), q = E && qa.call(t, "__wrapped__");
    if (F || q) {
      var G = F ? e.value() : e, H = q ? t.value() : t;
      return s || (s = new Hr()), a(G, H, r, n, s);
    }
  }
  return R ? (s || (s = new Hr()), Wv(e, t, r, n, a, s)) : !1;
}
var Xv = Yv, eg = Xv, Ka = ft;
function qs(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Ka(e) && !Ka(t) ? e !== e && t !== t : eg(e, t, r, n, qs, a);
}
var tg = qs, rg = tg;
function ng(e, t) {
  return rg(e, t);
}
var ag = ng;
const sg = /* @__PURE__ */ us(ag), Ba = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), Lr = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), Ze = {
  equals(e, t) {
    return sg(e, t);
  }
}, ig = f({
  id: z(c()),
  // Firebase Firestore ID
  url: c(),
  path: c(),
  headers: A(
    f({
      key: c(),
      value: c(),
      active: w()
    })
  ),
  params: A(
    f({
      key: c(),
      value: c(),
      active: w()
    })
  ),
  name: c(),
  method: c(),
  preRequestScript: c(),
  testScript: c(),
  contentType: c(),
  body: c(),
  rawParams: z(c()),
  auth: z(c()),
  httpUser: z(c()),
  httpPassword: z(c()),
  bearerToken: z(c())
}), Za = S({
  initial: !0,
  schema: ig
}), En = f({
  key: c(),
  active: w()
}).and(
  O([
    f({
      isFile: u(!0),
      value: A(gr(Blob).nullable())
    }),
    f({
      isFile: u(!1),
      value: c()
    })
  ])
);
f({
  contentType: u("multipart/form-data"),
  body: A(En)
});
const og = O([
  f({
    contentType: u(null),
    body: u(null).catch(null)
  }),
  f({
    contentType: u("multipart/form-data"),
    body: A(En).catch([])
  }),
  f({
    contentType: O([
      u("application/json"),
      u("application/ld+json"),
      u("application/hal+json"),
      u("application/vnd.api+json"),
      u("application/xml"),
      u("application/x-www-form-urlencoded"),
      u("text/html"),
      u("text/plain")
    ]),
    body: c().catch("")
  })
]), ae = f({
  authType: u("none")
}), se = f({
  authType: u("basic"),
  username: c().catch(""),
  password: c().catch("")
}), ie = f({
  authType: u("bearer"),
  token: c().catch("")
}), cg = f({
  authType: u("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), $n = f({
  authType: u("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), oe = f({
  authType: u("inherit")
}), ug = P("authType", [
  ae,
  oe,
  se,
  ie,
  cg,
  $n
]).and(
  f({
    authActive: w()
  })
), lg = A(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), Ks = A(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), Bs = f({
  v: u("1"),
  id: z(c()),
  // Firebase Firestore ID
  name: c(),
  method: c(),
  endpoint: c(),
  params: lg,
  headers: Ks,
  preRequestScript: c().catch(""),
  testScript: c().catch(""),
  auth: ug,
  body: og
});
function dg(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function fg(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const hg = S({
  initial: !1,
  schema: Bs,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l
    } = e, d = `${t}${r}`, y = dg(e), E = fg(e), R = {
      v: "1",
      endpoint: d,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: l,
      body: y,
      auth: E
    };
    return e.id && (R.id = e.id), R;
  }
}), wn = A(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0)
  })
), Zs = Bs.extend({
  v: u("2"),
  requestVariables: wn
}), pg = S({
  initial: !1,
  schema: Zs,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Fs = f({
  grantType: u("AUTHORIZATION_CODE"),
  authEndpoint: c().trim(),
  tokenEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch(""),
  isPKCE: w(),
  codeVerifierMethod: O([u("plain"), u("S256")]).optional()
}), _r = f({
  grantType: u("CLIENT_CREDENTIALS"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), br = f({
  grantType: u("PASSWORD"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  clientSecret: c().trim(),
  scopes: c().trim().optional(),
  username: c().trim(),
  password: c().trim(),
  token: c().catch("")
}), yt = f({
  grantType: u("IMPLICIT"),
  authEndpoint: c().trim(),
  clientID: c().trim(),
  scopes: c().trim().optional(),
  token: c().catch("")
}), Sr = f({
  authType: u("oauth-2"),
  grantTypeInfo: P("grantType", [
    Fs,
    _r,
    br,
    yt
  ]),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), yg = P("authType", [
  ae,
  oe,
  se,
  ie,
  Sr,
  $n
]).and(
  f({
    authActive: w()
  })
), Gs = Zs.extend({
  v: u("3"),
  auth: yg
}), mg = S({
  initial: !1,
  schema: Gs,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), $e = $n.extend({
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), vg = P("authType", [
  ae,
  oe,
  se,
  ie,
  Sr,
  $e
]).and(
  f({
    authActive: w()
  })
), Ws = Gs.extend({
  v: u("4"),
  auth: vg
}), gg = S({
  schema: Ws,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Js = Fs.extend({
  clientSecret: c().optional()
}), Ar = Sr.extend({
  grantTypeInfo: P("grantType", [
    Js,
    _r,
    br,
    yt
  ])
}), zs = P("authType", [
  ae,
  oe,
  se,
  ie,
  Ar,
  $e
]).and(
  f({
    authActive: w()
  })
), Qs = Ws.extend({
  v: u("5"),
  auth: zs
}), _g = S({
  schema: Qs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Ys = O([
  f({
    contentType: u(null),
    body: u(null).catch(null)
  }),
  f({
    contentType: u("multipart/form-data"),
    body: A(En).catch([])
  }),
  f({
    contentType: O([
      u("application/json"),
      u("application/ld+json"),
      u("application/hal+json"),
      u("application/vnd.api+json"),
      u("application/xml"),
      u("text/xml"),
      u("application/x-www-form-urlencoded"),
      u("text/html"),
      u("text/plain")
    ]),
    body: c().catch("")
  })
]), Xs = Qs.extend({
  v: u("6"),
  body: Ys
}), bg = S({
  schema: Xs,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), Tr = Js.extend({
  refreshToken: c().optional()
}), ei = f({
  authType: u("oauth-2"),
  grantTypeInfo: P("grantType", [
    Tr,
    _r,
    br,
    yt
  ]),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Rn = A(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0),
    description: c().catch(""),
    required: w().catch(!0).optional()
  })
), Er = A(
  f({
    key: c().catch(""),
    value: c().catch(""),
    active: w().catch(!0),
    description: c().catch("")
  })
), qe = f({
  authType: u("aws-signature"),
  accessKey: c().catch(""),
  secretKey: c().catch(""),
  region: c().catch(""),
  serviceName: c().catch(""),
  serviceToken: c().optional(),
  signature: f({}).optional(),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), ti = P("authType", [
  ae,
  oe,
  se,
  ie,
  ei,
  $e,
  qe
]).and(
  f({
    authActive: w()
  })
), ri = Xs.extend({
  v: u("7"),
  params: Rn,
  headers: Er,
  auth: ti
}), Sg = S({
  schema: ri,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: "",
      required: !1
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), ni = _r.extend({
  clientSecret: c().optional()
}), Cn = br.extend({
  clientSecret: c().optional()
}), Ag = f({
  authType: u("oauth-2"),
  grantTypeInfo: P("grantType", [
    Tr,
    ni,
    Cn,
    yt
  ]),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Rt = f({
  authType: u("digest"),
  username: c().catch(""),
  password: c().catch(""),
  realm: c().catch(""),
  nonce: c().catch(""),
  algorithm: Z(["MD5", "MD5-sess"]).catch("MD5"),
  qop: Z(["auth", "auth-int"]).catch("auth"),
  nc: c().catch(""),
  cnonce: c().catch(""),
  opaque: c().catch(""),
  disableRetry: w().catch(!1)
}), xn = P("authType", [
  ae,
  oe,
  se,
  ie,
  Ag,
  $e,
  qe,
  Rt
]).and(
  f({
    authActive: w()
  })
), ai = f({
  v: u("1"),
  name: c(),
  method: c(),
  endpoint: c(),
  headers: Er,
  params: Rn,
  body: Ys,
  auth: xn,
  requestVariables: wn
}), Fa = S({
  initial: !0,
  schema: ai
}), si = f({
  key: c(),
  active: w(),
  contentType: c().optional().catch(void 0)
}).and(
  O([
    f({
      isFile: u(!0),
      value: A(gr(Blob).nullable()).catch([])
    }),
    f({
      isFile: u(!1),
      value: c()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), ii = O([
  f({
    contentType: u(null),
    body: u(null).catch(null)
  }),
  f({
    contentType: u("multipart/form-data"),
    body: A(si).catch([]),
    showIndividualContentType: w().optional().catch(!1)
  }),
  f({
    contentType: u("application/octet-stream"),
    body: gr(File).nullable().catch(null)
  }),
  f({
    contentType: O([
      u("application/json"),
      u("application/ld+json"),
      u("application/hal+json"),
      u("application/vnd.api+json"),
      u("application/xml"),
      u("text/xml"),
      u("application/x-www-form-urlencoded"),
      u("binary"),
      u("text/html"),
      u("text/plain")
    ]),
    body: c().catch("")
  })
]), oi = ai.extend({
  v: u("2"),
  body: ii
}), Tg = S({
  initial: !1,
  schema: oi,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), ci = ni.extend({
  clientAuthentication: Z(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), $r = f({
  authType: u("oauth-2"),
  grantTypeInfo: P("grantType", [
    Tr,
    ci,
    Cn,
    yt
  ]),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), In = P("authType", [
  ae,
  oe,
  se,
  ie,
  $r,
  $e,
  qe,
  Rt
]).and(
  f({
    authActive: w()
  })
), On = O([
  f({
    contentType: u(null),
    body: u(null).catch(null)
  }),
  f({
    contentType: u("multipart/form-data"),
    body: A(si).catch([]),
    showIndividualContentType: w().optional().catch(!1),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: u("application/octet-stream"),
    body: gr(File).nullable().catch(null)
  }),
  f({
    contentType: u("application/x-www-form-urlencoded"),
    body: c().catch(""),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: O([
      u("application/json"),
      u("application/ld+json"),
      u("application/hal+json"),
      u("application/vnd.api+json"),
      u("application/xml"),
      u("text/xml"),
      u("binary"),
      u("text/html"),
      u("text/plain")
    ]),
    body: c().catch(""),
    bodyMandatory: Ls(Qm()).optional().catch({})
  })
]), ui = oi.extend({
  v: u("3"),
  auth: In,
  body: On
}), Eg = S({
  initial: !1,
  schema: ui,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), kn = f({
  authType: u("hawk"),
  authId: c().catch(""),
  authKey: c().catch(""),
  algorithm: Z(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: w().catch(!1),
  // Optional fields
  user: c().optional(),
  nonce: c().optional(),
  ext: c().optional(),
  app: c().optional(),
  dlg: c().optional(),
  timestamp: c().optional()
}), Pn = f({
  authType: u("akamai-eg"),
  accessToken: c().catch(""),
  clientToken: c().catch(""),
  clientSecret: c().catch(""),
  // Optional fields
  nonce: c().optional(),
  timestamp: c().optional(),
  host: c().optional(),
  headersToSign: c().optional(),
  maxBodySize: c().optional()
}), Vn = P("authType", [
  ae,
  oe,
  se,
  ie,
  $r,
  $e,
  qe,
  Rt,
  kn,
  Pn
]).and(
  f({
    authActive: w()
  })
), li = ui.extend({
  v: u("4"),
  auth: Vn
}), $g = S({
  initial: !1,
  schema: li,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), di = f({
  authType: u("jwt"),
  secret: c().catch(""),
  privateKey: c().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: Z([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: c().catch("{}"),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: w().catch(!1),
  headerPrefix: c().catch("Bearer "),
  paramName: c().catch("token"),
  jwtHeaders: c().catch("{}")
}), Nn = P("authType", [
  ae,
  oe,
  se,
  ie,
  $r,
  $e,
  qe,
  Rt,
  kn,
  Pn,
  di
]).and(
  f({
    authActive: w()
  })
), fi = li.extend({
  v: u("5"),
  auth: Nn
}), wg = S({
  initial: !1,
  schema: fi,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Te = f({
  id: pt(),
  key: c(),
  value: c(),
  active: w(),
  sendIn: Z(["headers", "url", "body"]).catch("headers")
}), hi = Te.omit({ sendIn: !0 }), Rg = Tr.extend({
  authRequestParams: A(hi).optional().default([]),
  tokenRequestParams: A(Te).optional().default([]),
  refreshRequestParams: A(Te).optional().default([])
}), Cg = ci.extend({
  tokenRequestParams: A(Te).optional().default([]),
  refreshRequestParams: A(Te).optional().default([])
}), xg = Cn.extend({
  tokenRequestParams: A(Te).optional().default([]),
  refreshRequestParams: A(Te).optional().default([])
}), Ig = yt.extend({
  authRequestParams: A(hi).optional().default([]),
  refreshRequestParams: A(Te).optional().default([])
}), pi = f({
  authType: u("oauth-2"),
  grantTypeInfo: P("grantType", [
    Rg,
    Cg,
    xg,
    Ig
  ]),
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), wr = P("authType", [
  ae,
  oe,
  se,
  ie,
  pi,
  $e,
  qe,
  Rt,
  kn,
  Pn,
  di
]).and(
  f({
    authActive: w()
  })
), Og = fi.extend({
  v: u("6"),
  auth: wr
}), kg = S({
  initial: !1,
  schema: Og,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "6",
      auth: t
    };
  }
}), Pg = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Vg = Ue({
  latestVersion: 6,
  versionMap: {
    1: Fa,
    2: Tg,
    3: Eg,
    4: $g,
    5: wg,
    6: kg
  },
  getVersion(e) {
    const t = Pg.safeParse(e);
    return t.success ? t.data.v : Fa.schema.safeParse(e).success ? 1 : null;
  }
}), Ng = "6", Mg = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, jg = O(
  Object.keys(Mg).map((e) => u(parseInt(e)))
), Dg = A(
  f({
    key: c(),
    value: c()
  })
), Hg = f({
  name: c(),
  originalRequest: nt(Vg),
  status: c(),
  code: z(jg).nullable().catch(null),
  headers: Dg,
  body: c()
}), Ga = S({
  initial: !0,
  schema: Hg
}), Lg = f({
  v: pt()
}), Ug = Ue({
  latestVersion: 0,
  versionMap: {
    0: Ga
  },
  getVersion(e) {
    const t = Lg.safeParse(e);
    return t.success ? t.data.v : Ga.schema.safeParse(e).success ? 0 : null;
  }
}), yi = Ls(
  c(),
  nt(Ug)
);
function tA(e) {
  return {
    v: Ng,
    ...e
  };
}
const mi = ri.extend({
  v: u("8"),
  auth: xn,
  responses: yi
}), qg = S({
  schema: mi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), vi = mi.extend({
  v: u("9"),
  body: ii
}), Kg = S({
  schema: vi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), gi = vi.extend({
  v: u("10"),
  body: On
}), Bg = S({
  schema: gi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), _i = gi.extend({
  v: u("11"),
  auth: In
}), Zg = S({
  schema: _i,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), bi = _i.extend({
  v: u("12"),
  auth: Vn
}), Fg = S({
  schema: bi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), Si = bi.extend({
  v: u("13"),
  auth: Nn
}), Gg = S({
  schema: Si,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), Ai = Si.extend({
  v: u("14")
}), Wg = S({
  schema: Ai,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), Jg = Ai.extend({
  v: u("15"),
  auth: wr,
  helpLink: c().optional().catch("")
}), zg = S({
  schema: Jg,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "15",
      auth: t,
      helpLink: ""
    };
  }
}), Qg = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, rA = Object.keys(
  Qg
), Yg = f({
  // v is a stringified number
  v: c().regex(/^\d+$/).transform(Number)
}), Rr = Ue({
  latestVersion: 15,
  versionMap: {
    0: Za,
    1: hg,
    2: pg,
    3: mg,
    4: gg,
    5: _g,
    6: bg,
    7: Sg,
    8: qg,
    9: Kg,
    10: Bg,
    11: Zg,
    12: Fg,
    13: Gg,
    14: Wg,
    15: zg
  },
  getVersion(e) {
    const t = Yg.safeParse(e);
    return t.success ? t.data.v : Za.schema.safeParse(e).success ? 0 : null;
  }
}), Xg = Vo({
  id: Ba(le),
  v: le,
  auth: Ze,
  body: Ze,
  endpoint: le,
  headers: Lr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ze
  ),
  params: Lr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ze
  ),
  method: le,
  name: le,
  preRequestScript: le,
  testScript: le,
  requestVariables: Lr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    Ze
  ),
  responses: Ze,
  helpLink: Ba(le)
}), Ti = "15", nA = Xg.equals;
function aA(e, t) {
  const r = $m(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = On.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = wr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Rn.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = Er.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = wn.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = yi.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
    "helpLink" in e && typeof e.helpLink == "string" && (r.helpLink = e.helpLink);
  }
  return r;
}
function sA(e) {
  return {
    v: Ti,
    ...e
  };
}
function e_() {
  return {
    v: Ti,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {},
    helpLink: ""
  };
}
function iA(e) {
  return Rr.isLatest(e);
}
function t_(e) {
  const t = Rr.safeParse(e);
  return t.type === "ok" ? t.value : e_();
}
const Mn = f({
  key: c().catch(""),
  value: c().catch(""),
  active: w().catch(!0)
}), r_ = f({
  v: u(1),
  name: c(),
  url: c(),
  headers: A(Mn).catch([]),
  query: c(),
  variables: c()
}), n_ = S({
  initial: !0,
  schema: r_
}), we = f({
  authType: u("none")
}), Re = f({
  authType: u("basic"),
  username: c().catch(""),
  password: c().catch("")
}), Ce = f({
  authType: u("bearer"),
  token: c().catch("")
}), a_ = f({
  authType: u("oauth-2"),
  token: c().catch(""),
  oidcDiscoveryURL: c().catch(""),
  authURL: c().catch(""),
  accessTokenURL: c().catch(""),
  clientID: c().catch(""),
  scope: c().catch("")
}), jn = f({
  authType: u("api-key"),
  key: c().catch(""),
  value: c().catch(""),
  addTo: c().catch("Headers")
}), xe = f({
  authType: u("inherit")
}), s_ = P("authType", [
  we,
  Re,
  Ce,
  a_,
  jn,
  xe
]).and(
  f({
    authActive: w()
  })
), Ei = f({
  id: z(c()),
  v: u(2),
  name: c(),
  url: c(),
  headers: A(Mn).catch([]),
  query: c(),
  variables: c(),
  auth: s_
}), i_ = S({
  initial: !1,
  schema: Ei,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), o_ = P("authType", [
  we,
  xe,
  Re,
  Ce,
  jn,
  Sr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), $i = Ei.extend({
  v: u(3),
  auth: o_
}), c_ = S({
  initial: !1,
  schema: $i,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), mt = jn.extend({
  addTo: Z(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), u_ = P("authType", [
  we,
  xe,
  Re,
  Ce,
  mt,
  Ar
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), wi = $i.extend({
  v: u(4),
  auth: u_
}), l_ = S({
  initial: !1,
  schema: wi,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), Ri = P("authType", [
  we,
  xe,
  Re,
  Ce,
  mt,
  Ar
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), Ci = wi.extend({
  v: u(5),
  auth: Ri
}), d_ = S({
  initial: !1,
  schema: Ci,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Cr = qe, xi = f({
  key: c().catch(""),
  value: c().catch(""),
  active: w().catch(!0),
  description: c().catch("")
}), Ii = P("authType", [
  we,
  xe,
  Re,
  Ce,
  Ar,
  mt,
  Cr
]).and(
  f({
    authActive: w()
  })
), Oi = Ci.extend({
  v: u(6),
  auth: Ii,
  headers: A(xi).catch([])
}), f_ = S({
  schema: Oi,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), ki = P("authType", [
  we,
  xe,
  Re,
  Ce,
  ei,
  mt,
  Cr
]).and(
  f({
    authActive: w()
  })
), Pi = Oi.extend({
  v: u(7),
  auth: ki
}), h_ = S({
  schema: Pi,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), xr = P("authType", [
  we,
  xe,
  Re,
  Ce,
  $r,
  mt,
  Cr
]).and(
  f({
    authActive: w()
  })
), Vi = Pi.extend({
  v: u(8),
  auth: xr
}), p_ = S({
  schema: Vi,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Ni = P("authType", [
  we,
  xe,
  Re,
  Ce,
  pi,
  mt,
  Cr
]).and(
  f({
    authActive: w()
  })
), y_ = Vi.extend({
  v: u(9),
  auth: Ni
}), m_ = S({
  schema: y_,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t
    };
  }
}), Mi = 9, v_ = f({
  v: pt()
}), Dn = Ue({
  latestVersion: 9,
  versionMap: {
    1: n_,
    2: i_,
    3: c_,
    4: l_,
    5: d_,
    6: f_,
    7: h_,
    8: p_,
    9: m_
  },
  getVersion(e) {
    const t = v_.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), g_ = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function __() {
  return {
    v: Mi,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: g_,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function b_(e) {
  const t = Dn.safeParse(e);
  return t.type === "ok" ? t.value : __();
}
function oA(e) {
  return {
    v: Mi,
    ...e
  };
}
const S_ = f({
  v: u(1),
  id: z(c()),
  // For Firestore ID data
  name: c(),
  requests: A(
    Y(
      () => O([
        nt(Rr),
        nt(Dn)
      ])
    )
  )
}), A_ = S_.extend({
  folders: Y(() => A(me(U, 1)))
}), Wa = S({
  initial: !0,
  schema: A_
}), ji = f({
  v: u(2),
  id: z(c()),
  // For Firestore ID data
  name: c(),
  requests: A(
    Y(
      () => O([
        nt(Rr),
        nt(Dn)
      ])
    )
  ),
  auth: O([zs, Ri]),
  headers: O([Ks, A(Mn)])
}), T_ = ji.extend({
  folders: Y(() => A(me(U, 2)))
}), E_ = S({
  initial: !1,
  schema: T_,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = U.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), Di = ji.extend({
  v: u(3),
  // AWS Signature Authorization type addition
  auth: O([ti, Ii]),
  // `description` field addition under `headers`
  headers: O([Er, A(xi)])
}), $_ = Di.extend({
  folders: Y(() => A(me(U, 3)))
}), w_ = S({
  initial: !1,
  schema: $_,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = U.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Hi = Di.extend({
  v: u(4),
  auth: O([xn, ki])
}), R_ = Hi.extend({
  folders: Y(() => A(me(U, 4)))
}), C_ = S({
  initial: !1,
  schema: R_,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = U.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
});
var L = [];
for (var Ur = 0; Ur < 256; ++Ur)
  L.push((Ur + 256).toString(16).slice(1));
function x_(e, t = 0) {
  return (L[e[t + 0]] + L[e[t + 1]] + L[e[t + 2]] + L[e[t + 3]] + "-" + L[e[t + 4]] + L[e[t + 5]] + "-" + L[e[t + 6]] + L[e[t + 7]] + "-" + L[e[t + 8]] + L[e[t + 9]] + "-" + L[e[t + 10]] + L[e[t + 11]] + L[e[t + 12]] + L[e[t + 13]] + L[e[t + 14]] + L[e[t + 15]]).toLowerCase();
}
var Ht, I_ = new Uint8Array(16);
function O_() {
  if (!Ht && (Ht = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ht))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ht(I_);
}
var k_ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Ja = {
  randomUUID: k_
};
function P_(e, t, r) {
  if (Ja.randomUUID && !t && !e)
    return Ja.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || O_)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, x_(n);
}
const Li = (e = "") => {
  const t = Date.now().toString(36), r = P_();
  return `${e}_${t}_${r}`;
}, Ui = Hi.extend({
  v: u(5),
  _ref_id: c().optional()
}), V_ = Ui.extend({
  folders: Y(() => A(me(U, 5)))
}), N_ = S({
  initial: !1,
  schema: V_,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: Li("coll"),
      folders: e.folders.map((r) => {
        const n = U.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), qi = Ui.extend({
  v: u(6),
  auth: O([In, xr])
}), M_ = qi.extend({
  folders: Y(() => A(me(U, 6)))
}), j_ = S({
  initial: !1,
  schema: M_,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = U.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), Ki = qi.extend({
  v: u(7),
  auth: O([Vn, xr])
}), D_ = Ki.extend({
  folders: Y(() => A(me(U, 7)))
}), H_ = S({
  initial: !1,
  schema: D_,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = U.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Bi = Ki.extend({
  v: u(8),
  auth: O([Nn, xr])
}), L_ = Bi.extend({
  folders: Y(() => A(me(U, 8)))
}), U_ = S({
  initial: !1,
  schema: L_,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = U.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), q_ = Bi.extend({
  v: u(9),
  auth: O([wr, Ni])
}), K_ = q_.extend({
  folders: Y(() => A(me(U, 9)))
}), B_ = S({
  initial: !1,
  schema: K_,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const n = e.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, t = {
        ...e.auth,
        grantTypeInfo: a
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t,
      folders: e.folders.map((n) => {
        const a = U.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Z_ = f({
  v: pt()
}), U = Ue({
  latestVersion: 9,
  versionMap: {
    1: Wa,
    2: E_,
    3: w_,
    4: C_,
    5: N_,
    6: j_,
    7: H_,
    8: U_,
    9: B_
  },
  getVersion(e) {
    const t = Z_.safeParse(e);
    return t.success ? t.data.v : Wa.schema.safeParse(e).success ? 1 : null;
  }
}), F_ = 9;
function Zi(e) {
  return {
    v: F_,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : Li("coll")
  };
}
function G_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(G_), n = (e.requests ?? []).map(t_), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = Zi({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
function W_(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(W_), n = (e.requests ?? []).map(b_), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = Zi({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s
  });
  return e.id && (i.id = e.id), e._ref_id && (i._ref_id = e._ref_id), i;
}
var Ie = function(e) {
  return function(t) {
    return !e(t);
  };
}, J_ = Jo, z_ = Go;
function Fi(e, t) {
  return t === void 0 ? function(r) {
    return Fi(e, r);
  } : z_(e, t) ? ss : is(t[e]);
}
var Gi = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, Q_ = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      as(a) && r.push(a.value);
    }
    return r;
  };
}, Y_ = function(e) {
  return Q_(function(t, r) {
    return e(r);
  });
}, Wi = function(e) {
  return e.slice();
}, X_ = Fo, za = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, eb = function(e) {
  return function(t) {
    return za(za([], t, !0), [e], !1);
  };
}, tb = eb, rb = function(e) {
  return [e];
}, nb = tb, ab = Fi, sb = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, ib = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, ob = function() {
  return {
    concat: ib().concat,
    empty: []
  };
}, Ir = ss, Ct = is;
function Ji(e) {
  return function(t) {
    return e(t) ? Ct(t) : Ir;
  };
}
var an = function(e) {
  return function(t) {
    return zi(t) ? Ir : Ct(e(t.value));
  };
}, cb = as, zi = function(e) {
  return e._tag === "None";
}, ub = function(e, t) {
  return function(r) {
    return zi(r) ? e() : t(r.value);
  };
}, lb = ub, Hn = lb, db = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Oe = jo, re = Do, fb = /* @__PURE__ */ ko(2, function(e, t) {
  return at(e) ? e : t(e.right);
}), xt = function(e) {
  return function(t) {
    return at(t) ? t : re(e(t.right));
  };
}, Or = function(e) {
  return function(t) {
    return at(t) ? Oe(e(t.left)) : t;
  };
}, at = No, hb = Mo, pb = function(e) {
  return function(t) {
    return at(t) ? e(t.left) : t.right;
  };
}, Ln = pb, Qa = fb, sr = function() {
  return sr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, sr.apply(this, arguments);
}, It = function(e, t, r) {
  return re({
    value: e,
    next: t,
    start: r
  });
}, Ot = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Oe({
    input: e,
    expected: t,
    fatal: r
  });
}, yb = function(e, t) {
  return sr(sr({}, e), { expected: t });
}, mb = function(e, t) {
  return vb().concat(e, t);
}, vb = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Bo().concat(e, t) : e.input.cursor > t.input.cursor ? Nr().concat(e, t) : Ko({
        input: Nr(),
        fatal: Nr(),
        expected: ob()
      }).concat(e, t);
    }
  };
}, gb = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, _b = function(e) {
  return ab(e.cursor, e.buffer);
}, bb = function(e) {
  return e.cursor >= e.buffer.length;
}, Sb = function(e) {
  return _(_b(e), an(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, Ee = function() {
  return Ee = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ee.apply(this, arguments);
}, Un = function(e) {
  return function(t) {
    return It(e, t, t);
  };
}, Ab = function() {
  return function(e) {
    return Ot(e);
  };
}, Tb = function(e) {
  return function() {
    return Ot(e);
  };
}, D = function(e) {
  return _(wb(Eb()), Ke(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? st(r) : Tb(n);
  }));
}, j = function(e, t) {
  return function(r) {
    return _(e(r), Or(function(n) {
      return yb(n, [t]);
    }));
  };
}, Eb = function() {
  return function(e) {
    return _(Sb(e), Hn(function() {
      return Ot(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return It(r, n, e);
    }));
  };
}, $b = function(e, t) {
  return function(r) {
    return _(e(r), Qa(function(n) {
      return _(t(n.value)(n.next), Qa(function(a) {
        return It(a.value, a.next, r);
      }));
    }));
  };
}, kr = function(e, t) {
  return function(r) {
    var n = e(r);
    return hb(n) || n.left.fatal ? n : _(t()(r), Or(function(a) {
      return mb(n.left, a);
    }));
  };
}, wb = function(e) {
  return function(t) {
    return _(e(t), xt(function(r) {
      return Ee(Ee({}, r), { value: [r.value, t] });
    }));
  };
}, Qi = function(e) {
  return Be(function() {
    return st(e.empty);
  });
}, qn = function() {
  return j(function(e) {
    return bb(e) ? It(void 0, e, e) : Ot(e);
  }, "end of file");
}, Rb = function(e) {
  return _(Kn(e), Be(function() {
    return st([]);
  }));
}, Kn = function(e) {
  return _(e, Ke(function(t) {
    return Zn(rb(t), function(r) {
      return _(e, M(function(n) {
        return Oe(nb(n)(r));
      }), Be(function() {
        return st(re(r));
      }));
    });
  }));
}, Cb = function(e, t) {
  return function(r) {
    return _(e, Ke(function() {
      return r;
    }), Fn(function() {
      return t;
    }));
  };
}, Yi = function(e) {
  return Cb(e, e);
}, xb = function(e) {
  return Rb(D(Ie(e)));
}, Bn = function(e, t) {
  return _(t, M(function() {
    return X_;
  }), Be(function() {
    return Ib(e, t);
  }));
}, Ib = function(e, t) {
  return _(e, Ke(function(r) {
    return Zn(zo(r), function(n) {
      return _(t, M(function() {
        return re(n);
      }), Be(function() {
        return _(e, M(function(a) {
          return Oe(J_(a)(n));
        }));
      }));
    });
  }));
}, kt = function(e, t) {
  return function(r) {
    return _(e(r), xt(function(n) {
      return Ee(Ee({}, n), { value: t(n.value) });
    }));
  };
}, Xi = function(e, t) {
  return Pr(e, function(r) {
    return kt(t, r);
  });
}, Pr = function(e, t) {
  return $b(e, t);
}, Zn = function(e, t) {
  var r = function(n) {
    return function(a) {
      return at(a.value) ? Oe({ value: a.value.left, stream: a.next }) : re(It(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return db({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return at(s) ? re(Ot(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, Ob = function(e, t) {
  return kr(e, t);
}, M = function(e) {
  return function(t) {
    return kt(t, e);
  };
}, st = Un, Ke = function(e) {
  return function(t) {
    return Pr(t, e);
  };
}, Fn = function(e) {
  return function(t) {
    return Pr(t, function(r) {
      return kt(e(r), function() {
        return r;
      });
    });
  };
}, Be = function(e) {
  return function(t) {
    return Ob(t, e);
  };
}, kb = "Parser", Pb = function(e) {
  return {
    concat: function(t, r) {
      return Xi(kt(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, Vb = function(e) {
  return Ee(Ee({}, Pb(e)), { empty: Un(e.empty) });
}, Nb = {
  URI: kb,
  map: kt,
  ap: Xi,
  chain: Pr,
  chainRec: Zn
}, eo = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, to = function(e) {
  return function(t) {
    return _(t, M(function(r) {
      return eo({}, e, r);
    }));
  };
}, sn = function(e, t) {
  return function(r) {
    return _(r, Ke(function(n) {
      return _(t(n), M(function(a) {
        return eo(n, e, a);
      }));
    }));
  };
}, Mb = function(e) {
  return Zo(e)(e.empty);
}, jb = Qi(ln), it = function(e) {
  return j(D(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, Db = function(e) {
  return j(D(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Gn = function(e) {
  return jb(Pt(e));
}, Pt = function(e) {
  return _(Kn(e), M(function(t) {
    return t.join("");
  }));
}, Wn = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, on = j(D(Wn), "a digit"), Hb = /^\s$/, ro = function(e) {
  return Hb.test(e);
}, no = j(D(ro), "a whitespace"), Lb = function(e) {
  return e === "_";
}, Vt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, ao = function(e) {
  return Vt(e) || Wn(e) || Lb(e);
};
j(D(ao), "a word character");
j(D(Vt), "a letter");
var Ub = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
j(D(Ub), "an unicode letter");
var so = function(e) {
  return Vt(e) && e === e.toUpperCase();
};
j(D(so), "an upper case letter");
var io = function(e) {
  return Vt(e) && e === e.toLowerCase();
};
j(D(io), "a lower case letter");
j(D(Ie(Wn)), "a non-digit");
var oo = j(D(Ie(ro)), "a non-whitespace character");
j(D(Ie(ao)), "a non-word character");
j(D(Ie(Vt)), "a non-letter character");
j(D(Ie(so)), "anything but an upper case letter");
j(D(Ie(io)), "anything but a lower case letter");
var co = function(e) {
  return j(Nb.chainRec(e, function(t) {
    return _(Bb(0, t), Hn(function() {
      return st(re(e));
    }, function(r) {
      return _(it(r), Ke(function() {
        return st(Oe(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, cn = Mb(Vb(ln)), Et = Qi(ln), qb = function(e) {
  return Et(Kb(e));
}, Kb = function(e) {
  return _(Kn(e), M(function(t) {
    return t.join("");
  }));
}, Bb = function(e, t) {
  return e < t.length ? Ct(t.charAt(e)) : Ir;
}, Zb = Gn(no);
Pt(no);
Gn(oo);
Pt(oo);
var Fb = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? Ir : Ct(t);
};
j(_(cn([Et(it("-")), Pt(on)]), M(function(e) {
  return +e;
})), "an integer");
j(_(cn([Et(it("-")), Gn(on), Et(cn([it("."), Pt(on)]))]), Ke(function(e) {
  return _(Fb(e), Hn(function() {
    return Ab();
  }, Un));
})), "a float");
var Gb = Yi(it('"'))(qb(kr(co('\\"'), function() {
  return Db('"');
})));
function uo(e) {
  return function(t) {
    return t(gb(e.split("")));
  };
}
const Ya = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), Wb = ["#", ":"], ot = Yi(Zb), Jn = (e) => (t) => t.join(e), zn = (e) => _(
  xb((t) => e.includes(t)),
  M(Jn(""))
), Jb = Se(
  zn,
  Fn(() => D(() => !0))
), lo = _(
  Gb,
  M((e) => JSON.parse(`"${e}"`))
), zb = _(
  ot(lo),
  Be(
    () => _(
      zn([":", `
`]),
      M(os)
    )
  )
), Qb = _(
  ot(lo),
  Be(
    () => _(
      zn([`
`]),
      M(os)
    )
  )
), fo = _(
  Et(co("#")),
  M(Ie(cs))
), ho = _(
  ot(fo),
  to("commented"),
  sn("key", () => ot(zb)),
  Fn(() => it(":")),
  sn("value", () => Qb)
), Yb = _(
  ot(fo),
  to("commented"),
  sn("key", () => kr(
    Jb([`
`]),
    () => _(
      Bn(D((e) => !0), qn()),
      M(Se(
        Wi,
        Jn("")
      ))
    )
  )),
  M(Se(
    Ji(({ key: e }) => !cs(e))
  ))
), Xb = _(
  Bn(ot(ho), qn())
), eS = _(
  Bn(
    kr(
      _(ho, M(Ct)),
      () => _(
        Yb,
        M(Se(
          an((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    qn()
  ),
  M(Se(
    Y_(Se(
      Ji(cb),
      an((e) => e.value)
    ))
  ))
), tS = (e) => {
  if (Wb.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Xa = (e) => tS(e) ? JSON.stringify(e) : e, cA = (e) => _(
  e,
  sb(
    Se(
      Ya("key", Xa),
      Ya("value", Xa),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  Jn(`
`)
), rS = (e) => _(
  eS,
  uo(e),
  Or((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  xt(
    ({ value: t }) => _(
      t,
      Gi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), uA = (e) => _(
  Xb,
  uo(e),
  Or((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  xt(
    ({ value: t }) => _(
      t,
      Gi(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), lA = Se(
  rS,
  xt(Wi),
  Ln(() => [])
), nS = f({
  id: z(c()),
  name: c(),
  variables: A(
    f({
      key: c(),
      value: c()
    })
  )
}), es = S({
  initial: !0,
  schema: nS
}), po = () => Math.random().toString(36).substring(2, 16), yo = f({
  v: u(1),
  id: c(),
  name: c(),
  variables: A(
    O([
      f({
        key: c(),
        secret: u(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: u(!1).catch(!1)
      })
    ])
  )
}), aS = S({
  initial: !1,
  schema: yo,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || po(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), sS = yo.extend({
  v: u(2),
  variables: A(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: w()
    })
  )
}), iS = S({
  initial: !1,
  schema: sS,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), mo = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], oS = f({
  v: pt()
}), dA = Ue({
  latestVersion: 2,
  versionMap: {
    0: es,
    1: aS,
    2: iS
  },
  getVersion(e) {
    const t = oS.safeParse(e);
    return t.success ? t.data.v : es.schema.safeParse(e).success ? 0 : null;
  }
}), ir = /<<([^>]*)>>/g, or = 10, vo = "ENV_EXPAND_LOOP", ts = 2;
function cS(e, t) {
  let r = e, n = 0;
  for (; r.match(ir) != null && n <= or; )
    r = r.replace(ir, (a) => {
      const s = a.replace(/[<>]/g, ""), i = mo.find(
        (l) => l.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((l) => l.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > or ? Oe(vo) : re(r);
}
const fA = (e, t) => _(
  cS(e, t),
  Ln(() => e)
);
function uS(e, t, r = !1, n = !1) {
  if (!t || !e)
    return re(e);
  let a = e, s = 0, i = !1;
  for (; a.match(ir) != null && s <= or && !i; )
    a = decodeURI(encodeURI(a)).replace(ir, (o, l) => {
      const d = mo.find(
        (E) => E.key === l
      );
      if (d)
        return d.getValue();
      const y = t.find((E) => E && E.key === l);
      return y && "currentValue" in y ? y.secret && n ? (i = !0, `<<${l}>>`) : y.secret && r ? "*".repeat(
        y.currentValue.length
      ) : y.currentValue : "";
    }), s++;
  return s > or ? Oe(vo) : re(a);
}
const hA = (e, t, r = !1, n = !1) => _(
  uS(e, t, r, n),
  Ln(() => e)
), lS = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), pA = (e) => {
  if (e.v && e.v === ts) return e;
  const t = e.id || po(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(lS);
  return {
    v: ts,
    id: t,
    name: r,
    variables: n
  };
}, dS = A(
  O([
    f({
      key: c(),
      value: c(),
      secret: u(!1)
    }),
    f({
      key: c(),
      secret: u(!0)
    }),
    f({
      key: c(),
      value: c()
    })
  ])
), rs = S({
  initial: !0,
  schema: dS
}), go = f({
  v: u(1),
  variables: A(
    O([
      f({
        key: c(),
        secret: u(!0)
      }),
      f({
        key: c(),
        value: c(),
        secret: u(!1)
      })
    ])
  )
}), fS = S({
  initial: !1,
  schema: go,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), hS = go.extend({
  v: u(2),
  variables: A(
    f({
      key: c(),
      initialValue: c(),
      currentValue: c(),
      secret: w()
    })
  )
}), pS = S({
  initial: !1,
  schema: hS,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), yS = f({
  v: pt()
}), yA = Ue({
  latestVersion: 2,
  versionMap: {
    0: rs,
    1: fS,
    2: pS
  },
  getVersion(e) {
    const t = yS.safeParse(e);
    return t.success ? t.data.v : rs.schema.safeParse(e).success ? 0 : null;
  }
});
async function mS(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function vS(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function gS(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function _S(e, t) {
  return t === "sha256" ? vS(e) : gS(e);
}
async function bS(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), l = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(l)]));
}
function Fe(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function SS(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), Fe(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), Fe(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return Fe(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return Fe(JSON.stringify(r));
    } catch {
      return Fe(e.toString());
    }
  return Fe(e.toString());
}
async function mA(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await mS(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const E = e.contentType || "text/plain", R = await SS(e.payload, E), F = `hawk.1.payload
${E}
${R}
`, q = await _S(F, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(q)])
      );
    } catch (E) {
      console.error("Error calculating payload hash:", E);
    }
  const l = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, d = await bS(e.key, l, e.algorithm), y = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${d}"`
  ];
  return e.ext && e.ext !== "" && y.push(`ext="${e.ext}"`), e.app && e.app !== "" && y.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && y.push(`dlg="${e.dlg}"`), o.hash !== "" && y.push(`hash="${o.hash}"`), y.join(", ");
}
async function vA(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const E = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(E)).map((R) => R.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, l = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), d = btoa(
    String.fromCharCode(...new Uint8Array(l))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${d}`;
}
const ze = new TextEncoder(), cr = new TextDecoder();
function AS(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function TS(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function ES(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function $S(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : cr.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = cr.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return ES(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function qr(e) {
  let t = e;
  return typeof t == "string" && (t = ze.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : TS(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Vr extends Error {
  constructor(r, n) {
    var a;
    super(r, n);
    ce(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (a = Error.captureStackTrace) == null || a.call(Error, this, this.constructor);
  }
}
ce(Vr, "code", "ERR_JOSE_GENERIC");
class Me extends Vr {
  constructor() {
    super(...arguments);
    ce(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
ce(Me, "code", "ERR_JOSE_NOT_SUPPORTED");
class We extends Vr {
  constructor() {
    super(...arguments);
    ce(this, "code", "ERR_JWS_INVALID");
  }
}
ce(We, "code", "ERR_JWS_INVALID");
class _o extends Vr {
  constructor() {
    super(...arguments);
    ce(this, "code", "ERR_JWT_INVALID");
  }
}
ce(_o, "code", "ERR_JWT_INVALID");
function ue(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function gt(e, t) {
  return e.name === t;
}
function Kr(e) {
  return parseInt(e.name.slice(4), 10);
}
function wS(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function RS(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function CS(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!gt(e.algorithm, "HMAC"))
        throw ue("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (Kr(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!gt(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw ue("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (Kr(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!gt(e.algorithm, "RSA-PSS"))
        throw ue("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (Kr(e.algorithm.hash) !== n)
        throw ue(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!gt(e.algorithm, "Ed25519"))
        throw ue("Ed25519");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!gt(e.algorithm, "ECDSA"))
        throw ue("ECDSA");
      const n = wS(t);
      if (e.algorithm.namedCurve !== n)
        throw ue(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  RS(e, r);
}
function bo(e, t, ...r) {
  var n;
  if (r = r.filter(Boolean), r.length > 2) {
    const a = r.pop();
    e += `one of type ${r.join(", ")}, or ${a}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && (n = t.constructor) != null && n.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const xS = (e, ...t) => bo("Key must be ", e, ...t);
function So(e, t, ...r) {
  return bo(`Key for the ${e} algorithm must be `, t, ...r);
}
function Ao(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "CryptoKey";
}
function To(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "KeyObject";
}
const Eo = (e) => Ao(e) || To(e), IS = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
};
function OS(e) {
  return typeof e == "object" && e !== null;
}
const $o = (e) => {
  if (!OS(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, kS = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function PS(e) {
  let t, r;
  switch (e.kty) {
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Me('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Me('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Me('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new Me('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const VS = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = PS(e), n = { ...e };
  return delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !e.d, e.key_ops ?? r);
}, NS = (e, t, r, n, a) => {
  if (a.crit !== void 0 && (n == null ? void 0 : n.crit) === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Me(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
};
function Qn(e) {
  return $o(e) && typeof e.kty == "string";
}
function MS(e) {
  return e.kty !== "oct" && typeof e.d == "string";
}
function jS(e) {
  return e.kty !== "oct" && typeof e.d > "u";
}
function DS(e) {
  return e.kty === "oct" && typeof e.k == "string";
}
let Qe;
const ns = async (e, t, r, n = !1) => {
  Qe || (Qe = /* @__PURE__ */ new WeakMap());
  let a = Qe.get(e);
  if (a != null && a[r])
    return a[r];
  const s = await VS({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : Qe.set(e, { [r]: s }), s;
}, HS = (e, t) => {
  var i;
  Qe || (Qe = /* @__PURE__ */ new WeakMap());
  let r = Qe.get(e);
  if (r != null && r[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  if (e.asymmetricKeyType === "rsa") {
    let o;
    switch (t) {
      case "RSA-OAEP":
        o = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        o = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        o = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        o = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: o
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: o
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const l = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get((i = e.asymmetricKeyDetails) == null ? void 0 : i.namedCurve);
    if (!l)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && l === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: l
    }, a, [n ? "verify" : "sign"])), t === "ES384" && l === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: l
    }, a, [n ? "verify" : "sign"])), t === "ES512" && l === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: l
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: l
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : Qe.set(e, { [t]: s }), s;
}, LS = async (e, t) => {
  if (e instanceof Uint8Array || Ao(e))
    return e;
  if (To(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return HS(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return ns(e, r, t);
  }
  if (Qn(e))
    return e.k ? $S(e.k) : ns(e, e, t, !0);
  throw new Error("unreachable");
}, Je = (e) => e == null ? void 0 : e[Symbol.toStringTag], un = (e, t, r) => {
  var n, a;
  if (t.use !== void 0) {
    let s;
    switch (r) {
      case "sign":
      case "verify":
        s = "sig";
        break;
      case "encrypt":
      case "decrypt":
        s = "enc";
        break;
    }
    if (t.use !== s)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${s}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let s;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        s = r;
        break;
      case e.startsWith("PBES2"):
        s = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? s = "unwrapKey" : s = r;
        break;
      case r === "encrypt":
        s = "wrapKey";
        break;
      case r === "decrypt":
        s = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (s && ((a = (n = t.key_ops) == null ? void 0 : n.includes) == null ? void 0 : a.call(n, s)) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${s}" when present`);
  }
  return !0;
}, US = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (Qn(t)) {
      if (DS(t) && un(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!Eo(t))
      throw new TypeError(So(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${Je(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, qS = (e, t, r) => {
  if (Qn(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (MS(t) && un(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "encrypt":
      case "verify":
        if (jS(t) && un(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!Eo(t))
    throw new TypeError(So(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${Je(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${Je(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${Je(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${Je(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${Je(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
}, KS = (e, t, r) => {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(e) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(e) ? US(e, t, r) : qS(e, t, r);
}, BS = (e, t) => {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    default:
      throw new Me(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}, ZS = async (e, t, r) => {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(xS(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return CS(t, e, r), t;
}, Pe = (e) => Math.floor(e.getTime() / 1e3), wo = 60, Ro = wo * 60, Yn = Ro * 24, FS = Yn * 7, GS = Yn * 365.25, WS = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, Br = (e) => {
  const t = WS.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * wo);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * Ro);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * Yn);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * FS);
      break;
    default:
      a = Math.round(r * GS);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
};
function Ve(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
var V;
class JS {
  constructor(t) {
    ve(this, V);
    if (!$o(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    ge(this, V, structuredClone(t));
  }
  data() {
    return ze.encode(JSON.stringify(g(this, V)));
  }
  get iss() {
    return g(this, V).iss;
  }
  set iss(t) {
    g(this, V).iss = t;
  }
  get sub() {
    return g(this, V).sub;
  }
  set sub(t) {
    g(this, V).sub = t;
  }
  get aud() {
    return g(this, V).aud;
  }
  set aud(t) {
    g(this, V).aud = t;
  }
  set jti(t) {
    g(this, V).jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? g(this, V).nbf = Ve("setNotBefore", t) : t instanceof Date ? g(this, V).nbf = Ve("setNotBefore", Pe(t)) : g(this, V).nbf = Pe(/* @__PURE__ */ new Date()) + Br(t);
  }
  set exp(t) {
    typeof t == "number" ? g(this, V).exp = Ve("setExpirationTime", t) : t instanceof Date ? g(this, V).exp = Ve("setExpirationTime", Pe(t)) : g(this, V).exp = Pe(/* @__PURE__ */ new Date()) + Br(t);
  }
  set iat(t) {
    typeof t > "u" ? g(this, V).iat = Pe(/* @__PURE__ */ new Date()) : t instanceof Date ? g(this, V).iat = Ve("setIssuedAt", Pe(t)) : typeof t == "string" ? g(this, V).iat = Ve("setIssuedAt", Pe(/* @__PURE__ */ new Date()) + Br(t)) : g(this, V).iat = Ve("setIssuedAt", t);
  }
}
V = new WeakMap();
const zS = async (e, t, r) => {
  const n = await ZS(e, t, "sign");
  kS(e, n);
  const a = await crypto.subtle.sign(BS(e, n.algorithm), n, r);
  return new Uint8Array(a);
};
var $t, W, X;
class QS {
  constructor(t) {
    ve(this, $t);
    ve(this, W);
    ve(this, X);
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    ge(this, $t, t);
  }
  setProtectedHeader(t) {
    if (g(this, W))
      throw new TypeError("setProtectedHeader can only be called once");
    return ge(this, W, t), this;
  }
  setUnprotectedHeader(t) {
    if (g(this, X))
      throw new TypeError("setUnprotectedHeader can only be called once");
    return ge(this, X, t), this;
  }
  async sign(t, r) {
    if (!g(this, W) && !g(this, X))
      throw new We("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!IS(g(this, W), g(this, X)))
      throw new We("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...g(this, W),
      ...g(this, X)
    }, a = NS(We, /* @__PURE__ */ new Map([["b64", !0]]), r == null ? void 0 : r.crit, g(this, W), n);
    let s = !0;
    if (a.has("b64") && (s = g(this, W).b64, typeof s != "boolean"))
      throw new We('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new We('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    KS(i, t, "sign");
    let o = g(this, $t);
    s && (o = ze.encode(qr(o)));
    let l;
    g(this, W) ? l = ze.encode(qr(JSON.stringify(g(this, W)))) : l = ze.encode("");
    const d = AS(l, ze.encode("."), o), y = await LS(t, i), E = await zS(i, y, d), R = {
      signature: qr(E),
      payload: ""
    };
    return s && (R.payload = cr.decode(o)), g(this, X) && (R.header = g(this, X)), g(this, W) && (R.protected = cr.decode(l)), R;
  }
}
$t = new WeakMap(), W = new WeakMap(), X = new WeakMap();
var Ye;
class YS {
  constructor(t) {
    ve(this, Ye);
    ge(this, Ye, new QS(t));
  }
  setProtectedHeader(t) {
    return g(this, Ye).setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await g(this, Ye).sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
Ye = new WeakMap();
var be, J;
class XS {
  constructor(t = {}) {
    ve(this, be);
    ve(this, J);
    ge(this, J, new JS(t));
  }
  setIssuer(t) {
    return g(this, J).iss = t, this;
  }
  setSubject(t) {
    return g(this, J).sub = t, this;
  }
  setAudience(t) {
    return g(this, J).aud = t, this;
  }
  setJti(t) {
    return g(this, J).jti = t, this;
  }
  setNotBefore(t) {
    return g(this, J).nbf = t, this;
  }
  setExpirationTime(t) {
    return g(this, J).exp = t, this;
  }
  setIssuedAt(t) {
    return g(this, J).iat = t, this;
  }
  setProtectedHeader(t) {
    return ge(this, be, t), this;
  }
  async sign(t, r) {
    var a;
    const n = new YS(g(this, J).data());
    if (n.setProtectedHeader(g(this, be)), Array.isArray((a = g(this, be)) == null ? void 0 : a.crit) && g(this, be).crit.includes("b64") && g(this, be).b64 === !1)
      throw new _o("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
be = new WeakMap(), J = new WeakMap();
async function gA(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, l = {};
  try {
    const d = (a == null ? void 0 : a.trim()) || "{}";
    d === "" ? o = {} : o = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT payload JSON:", d), console.error("Payload value:", a), null;
  }
  try {
    const d = (s == null ? void 0 : s.trim()) || "{}";
    d === "" ? l = {} : l = JSON.parse(d);
  } catch (d) {
    return console.error("Failed to parse JWT headers JSON:", d), console.error("Headers value:", s), null;
  }
  try {
    let d;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      d = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      d = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new XS(o).setProtectedHeader({
      alg: t,
      ...l
    }).sign(d);
  } catch (d) {
    return console.error("Error generating JWT token:", d), null;
  }
}
export {
  Rg as AuthCodeGrantTypeParams,
  Cg as ClientCredentialsGrantTypeParams,
  F_ as CollectionSchemaVersion,
  dA as Environment,
  ts as EnvironmentSchemaVersion,
  si as FormDataKeyValue,
  xi as GQLHeader,
  Mi as GQL_REQ_SCHEMA_VERSION,
  yA as GlobalEnvironment,
  mo as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  U as HoppCollection,
  Ni as HoppGQLAuth,
  mt as HoppGQLAuthAPIKey,
  Cr as HoppGQLAuthAWSSignature,
  Re as HoppGQLAuthBasic,
  Ce as HoppGQLAuthBearer,
  xe as HoppGQLAuthInherit,
  we as HoppGQLAuthNone,
  pi as HoppGQLAuthOAuth2,
  Dn as HoppGQLRequest,
  wr as HoppRESTAuth,
  $e as HoppRESTAuthAPIKey,
  qe as HoppRESTAuthAWSSignature,
  Pn as HoppRESTAuthAkamaiEdgeGrid,
  se as HoppRESTAuthBasic,
  ie as HoppRESTAuthBearer,
  Rt as HoppRESTAuthDigest,
  kn as HoppRESTAuthHAWK,
  oe as HoppRESTAuthInherit,
  di as HoppRESTAuthJWT,
  ae as HoppRESTAuthNone,
  pi as HoppRESTAuthOAuth2,
  Er as HoppRESTHeaders,
  Rn as HoppRESTParams,
  On as HoppRESTReqBody,
  Rr as HoppRESTRequest,
  Ug as HoppRESTRequestResponse,
  yi as HoppRESTRequestResponses,
  wn as HoppRESTRequestVariables,
  Vg as HoppRESTResponseOriginalRequest,
  Ig as ImplicitOauthFlowParams,
  xg as PasswordGrantTypeParams,
  Ti as RESTReqSchemaVersion,
  rA as ValidContentTypesList,
  vA as calculateAkamaiEdgeGridHeader,
  mA as calculateHawkHeader,
  gA as generateJWTToken,
  Li as generateUniqueRefId,
  __ as getDefaultGQLRequest,
  e_ as getDefaultRESTRequest,
  nA as isEqualHoppRESTRequest,
  iA as isHoppRESTRequest,
  Qg as knownContentTypes,
  Zi as makeCollection,
  oA as makeGQLRequest,
  tA as makeHoppRESTResponseOriginalRequest,
  sA as makeRESTRequest,
  fA as parseBodyEnvVariables,
  cS as parseBodyEnvVariablesE,
  lA as parseRawKeyValueEntries,
  rS as parseRawKeyValueEntriesE,
  hA as parseTemplateString,
  uS as parseTemplateStringE,
  cA as rawKeyValueEntriesToString,
  aA as safelyExtractRESTRequest,
  uA as strictParseRawKeyValueEntriesE,
  b_ as translateToGQLRequest,
  pA as translateToNewEnvironment,
  lS as translateToNewEnvironmentVariables,
  W_ as translateToNewGQLCollection,
  G_ as translateToNewRESTCollection,
  t_ as translateToNewRequest
};
